webpackJsonp([3],{

/***/ "0EIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fill: {
      type: String,
      default: '#2196f3'
    }
  }
});

/***/ }),

/***/ "0enS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-slide-action-group",attrs:{"tabindex":"-1"},on:{"blur":_vm.reset}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0kyz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirSlideAction',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      transition: 'none',
      leftWidth: 0, // 左边容器宽
      rightWidth: 0, // 右边容器宽
      preOffset: 0, // 上一次的偏移值，记住上次滑动的位置
      offset: 0, // 实际偏移值，上次的值+当前移动的值，有做边界控制
      status: this.value // 状态0-默认  1-左边滑出  -1右边滑出 2-滑动中
    };
  },

  computed: {
    /**
     * 通过状态来计算位移的距离
     * @returns {number}
     */
    deltaX: function deltaX() {
      if (this.status === -1) {
        return -this.leftWidth - this.rightWidth;
      } else if (this.status === 1) {
        return 0;
      } else if (this.status === 2) {
        return this.offset;
      }
      return -this.leftWidth;
    },

    // 通过位移的距离，实时改变容器的transform,达到滑动的效果
    styleObject: function styleObject() {
      return {
        transition: this.transition,
        transform: 'translate3d(' + this.deltaX + 'px,0,0)'
      };
    }
  },
  mounted: function mounted() {
    // 初始化左右容器的宽度
    this.leftWidth = this.$refs.left ? this.$refs.left.clientWidth : 0;
    this.rightWidth = this.$refs.right ? this.$refs.right.clientWidth : 0;
    // 一开始的偏移是左边的容器宽
    this.preOffset = -this.leftWidth;
  },

  watch: {
    status: function status(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.status = val;
    }
  },
  methods: {
    // 移动开始
    onPanStart: function onPanStart(e) {
      if (this.status === 0) {
        this.$parent.$emit('slide-start');
        // e.direction === 4 && this.$refs.left && this.$parent.$emit('slide-start')
        // e.direction === 2 && this.$refs.right && this.$parent.$emit('slide-start')
      }
    },

    // 移动中，计算偏移值
    onPanMove: function onPanMove(e) {
      this.transition = 'none';
      this.status = 2;
      this.offset = Math.max(Math.min(this.preOffset + e.deltaX, 0), -this.leftWidth - this.rightWidth);
    },

    // 移动结束后，改变状态
    onPanEnd: function onPanEnd() {
      this.transition = 'all 300ms';
      if (this.deltaX >= -this.leftWidth) {
        // 相对位置往右滑动了
        if (Math.abs(this.deltaX) > this.leftWidth / 2) {
          // 滑动的距离不超过左边的一半宽，自动复位
          this.status = 0;
        } else {
          // 滑动的距离超过了左边的一半宽，自动把左边滑出
          this.status = 1;
        }
      } else {
        // 相对位置往坐滑动了
        if (Math.abs(this.deltaX) < this.leftWidth + this.rightWidth / 2) {
          // 滑动的距离不超过右边的一半宽，自动复位
          this.status = 0;
        } else {
          // 滑动的距离超过了左边的一半宽，自动把右边滑出
          this.status = -1;
        }
      }
      this.preOffset = this.deltaX;
      this.$emit('slide-end', this.status);
    },
    reset: function reset() {
      this.status = 0;
      this.preOffset = -this.leftWidth;
    }
  }
});

/***/ }),

/***/ "0wY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubble_vue__ = __webpack_require__("aUn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e17168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bubble_vue__ = __webpack_require__("BMRh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e17168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1YUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-data-block",on:{"click":_vm.retry}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.state === _vm.stateMap.ok)?_vm._t("default"):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.state === _vm.stateMap.loading)?_vm._t("loading",[_c('div',{staticClass:"air-data-block--loading"},[_c('loading',{staticClass:"air-data-block--loading__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.loadingText))])],1)]):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.state === _vm.stateMap.empty)?_vm._t("empty",[_c('div',[_vm._v(_vm._s(_vm.emptyText))])]):_vm._e()],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.state === _vm.stateMap.error)?_vm._t("error",[_c('div',[_c('span',[_vm._v(_vm._s(_vm.errorText))])])]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Qfd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2RCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AirLineMap_vue__ = __webpack_require__("3kDc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779c41dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AirLineMap_vue__ = __webpack_require__("fMDl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AirLineMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779c41dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AirLineMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2igs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = init;
/* unused harmony export getRenderConf */
/* unused harmony export mercator */
/* harmony export (immutable) */ __webpack_exports__["b"] = convert;
/* unused harmony export converts */
/* unused harmony export getPoint */
/* unused harmony export getPoints */
/* harmony export (immutable) */ __webpack_exports__["a"] = angle;
/* unused harmony export radian */
/* harmony export (immutable) */ __webpack_exports__["c"] = drawChinaMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/**
 * Created by 熊超超 on 2017/12/13.
 */
var radius = 6378137;
var max = 85.0511287798;
var radians = Math.PI / 180;
var renderConf = null;

function init(json, width, height) {
  renderConf = getRenderConf(json, width, height);
}

// 根据 geoJSON 及 canvas 宽高
// 返回 canvas 绘图所需坐标参数
function getRenderConf(geoJSON, canvasW, canvasH) {
  var coordinates = getAllCoordinates(geoJSON);
  var bound = getBound(coordinates);

  var _getScaleArgs = getScaleArgs([bound.w, bound.h], [canvasW, canvasH]),
      _getScaleArgs2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_getScaleArgs, 3),
      offsetX = _getScaleArgs2[0],
      offsetY = _getScaleArgs2[1],
      areaScale = _getScaleArgs2[2];

  return {
    json: geoJSON,
    height: canvasH,
    offsetX: offsetX,
    offsetY: offsetY,
    minX: bound.minX,
    minY: bound.minY,
    areaScale: areaScale
  };
}

// 由 area 地形数据返回所有子 subArea 经纬度数组
// 用于后续计算区域地形参数
function getAllCoordinates(geoJSON) {
  var coordinates = [];
  geoJSON.features.forEach(function (feature) {
    if (feature.geometry.type === 'Polygon') {
      feature.geometry.coordinates.forEach(function (shapeArr) {
        coordinates = coordinates.concat(shapeArr.map(function (x) {
          return mercator(x[0], x[1]);
        }));
      });
    } else {
      feature.geometry.coordinates.forEach(function (shapes) {
        shapes.forEach(function (shapeArr) {
          coordinates = coordinates.concat(shapeArr.map(function (x) {
            return mercator(x[0], x[1]);
          }));
        });
      });
    }
  });
  return coordinates;
}

// 由经纬度返回笛卡尔坐标系下的 x, y 投影
function mercator(longitude, latitude) {
  var x = radius * longitude * radians;
  var y = Math.max(Math.min(max, latitude), -max) * radians;
  y = radius * Math.log(Math.tan(Math.PI / 4 + y / 2));
  return [x, y];
}

// 输入源区域宽高
// 根据源区域比例及目标区域宽高
// 返回源映射至目标时的缩放参数与 x y 偏移量
function getScaleArgs(_ref, _ref2) {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      srcW = _ref4[0],
      srcH = _ref4[1];

  var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
      boundW = _ref3[0],
      boundH = _ref3[1];

  // 根据二者比例判断缩放后应填满目标区域 x 轴还是 y 轴
  var isFillX = srcW / srcH / (boundW / boundH) > 1;
  var scale = isFillX ? boundW / srcW : boundH / srcH;

  var offsetX = isFillX ? 0 : (boundW - srcW * scale) / 2;
  var offsetY = !isFillX ? 0 : (boundH - srcH * scale) / 2;

  return [offsetX, offsetY, scale];
}
// 返回 [[x, y]...] 二维数组区域宽高及该区域相对 [0, 0] 的偏移
function getBound(arr) {
  var minX = arr.reduce(function (a, b) {
    return a[0] < b[0] ? a : b;
  })[0];
  var maxX = arr.reduce(function (a, b) {
    return a[0] > b[0] ? a : b;
  })[0];
  var minY = arr.reduce(function (a, b) {
    return a[1] < b[1] ? a : b;
  })[1];
  var maxY = arr.reduce(function (a, b) {
    return a[1] > b[1] ? a : b;
  })[1];
  return { w: maxX - minX, h: maxY - minY, minX: minX, minY: minY };
}

///

// 将 [lat, lng] 经纬度坐标转换为当前 canvas 的 [x, y] 坐标
function convert(coordinate) {
  var conf = renderConf;
  return getPoint(coordinate, conf.minX, conf.minY, conf.offsetX, conf.offsetY, conf.areaScale, conf.height);
}

function converts(coordinate) {
  var conf = renderConf;
  return getPoints(coordinate, conf.minX, conf.minY, conf.offsetX, conf.offsetY, conf.areaScale, conf.height);
}

// 根据经纬度坐标及 canvas 绘图参数
// 返回单个 canvas 坐标
function getPoint(coordinate, minX, minY, offsetX, offsetY, areaScale, height) {
  return moveToOrigin(minX, minY, [coordinate]).map(function (p) {
    return [p[0] * areaScale + offsetX, height - p[1] * areaScale - offsetY];
  })[0];
}
// 根据经纬度数组及 canvas 绘图参数
// 返回 canvas 坐标数组
function getPoints(arr, minX, minY, offsetX, offsetY, areaScale, height) {
  return moveToOrigin(minX, minY, arr).map(function (p) {
    return [p[0] * areaScale + offsetX, height - p[1] * areaScale - offsetY];
  });
}

// 返回移动 [[x, y]...] 二维数组区域至原点的新数组
function moveToOrigin(minX, minY, arr) {
  return arr.map(function (p) {
    var _mercator = mercator(p[0], p[1]),
        _mercator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_mercator, 2),
        x = _mercator2[0],
        y = _mercator2[1];

    return [x - minX, y - minY];
  });
}

/**
 * 计算2点的角度
 * @param start 开始点坐标
 * @param end 结束点坐标
 * @param offset 修正角度，例如本例中，飞机的图标相对水平方向已经有90度，所以要传90来修正最终角度
 * @returns {number}
 */
function angle(start, end) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var diff_x = end[0] - start[0];
  var diff_y = end[1] - start[1];
  var a = 360 * Math.atan(diff_y / diff_x) / (2 * Math.PI);
  a = offset - a;
  if (a > 0 && diff_x > 0) {
    a += 180;
  }
  if (a < 0 && diff_x < 0) {
    a += -180;
  }
  return a;
}
// 计算2点的弧度
function radian(start, end) {
  var diff_x = end[0] - start[0];
  var diff_y = end[1] - start[1];
  return Math.atan(diff_y / diff_x);
}

function drawChinaMap(zrender, zr, style) {
  // 分省份返回中国地图在canvas的坐标
  renderConf.json.features.forEach(function (area) {
    if (area.geometry.type === 'Polygon') {
      area.geometry.coordinates.forEach(function (arr) {
        drawArae(converts(arr), zrender, zr, style);
      });
    } else {
      area.geometry.coordinates.forEach(function (s) {
        return s.forEach(function (arr) {
          drawArae(converts(arr), zrender, zr, style);
        });
      });
    }
  });
}

function drawArae(ps, zrender, zr, style) {
  zr.add(new zrender.Polygon({ style: style, shape: { points: ps } }));
}

/***/ }),

/***/ "3kDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender__ = __webpack_require__("zEoQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zrender__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("2igs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__china__ = __webpack_require__("iM+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__china___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__china__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__china_airport_location__ = __webpack_require__("J6+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__china_airport_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__china_airport_location__);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirLineMap',
  props: {
    mapFill: {
      type: String,
      default: '#DDD'
    },
    mapStroke: {
      type: String,
      default: '#BBB'
    },
    codes: {
      type: Array,
      required: true
    },
    iconSize: {
      type: Number,
      default: 20
    },
    iconFill: {
      type: String,
      default: '#000000'
    },
    iconZ: {
      type: Number,
      default: 100
    },
    lineStroke: {
      type: String,
      default: '#999'
    },
    lineZ: {
      type: Number,
      default: 0
    },
    dotR: {
      type: Number,
      default: 8
    },
    dotFill: {
      type: String,
      default: '#ff2d7d'
    },
    dotZ: {
      type: Number,
      default: 10
    },
    dotShadowBlur: {
      type: Number,
      default: 10
    },
    hd: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      zzIconL: {},
      dpr: 1,
      zr: null, // 画布实例
      timeStop: 1000,
      time: 5000,
      zzSvg: '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg t="1513587186952" class="icon" style="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="763" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><defs><style type="text/css"></style></defs><path d="M505.09248446 55.17408783c-251.53840199 0-455.48663077 203.89126651-455.48663077 455.48928069 0 251.59536428 203.94822877 455.48928069 455.48663077 455.4892807 251.54370054 0 455.49457923-203.89391641 455.49457923-455.4892807C960.58573808 259.06535562 756.63485939 55.17408783 505.09248446 55.17408783zM204.17422818 359.37099918c0-16.23298434 16.12965689-24.52036464 16.1296569-24.52036463s168.58114803-119.54571731 172.19892811-122.04676786c0 0 8.17080581-5.77970561 16.73107478-3.89199566 10.18038879 2.22551065 9.90220028 7.34021324 9.90220026 7.34021325l0 97.6919928 164.24537431 0c134.89247243 0 137.11400884 154.85318717 137.11400884 154.85318714 0-49.26460412-132.83387436-67.0580961-132.83387436-67.05809609l-168.52551009 0 0 91.40757262c0 0 0.10862599 7.34021324-10.01215057 9.45312363-9.28223683 2.0029601-20.29321819-1.99766156-20.29321821-1.99766155l-173.25472117-118.87806438C215.57599959 381.72281413 204.17422818 375.2158434 204.17422818 359.37099918zM789.83074315 686.64169077c0 0-168.75071055 119.65566893-172.36186649 122.21368173-1.61481999 1.11408093-6.11883061 4.78087483-13.34379369 3.89464429-10.8467174-1.44790739-12.62050281-7.45413779-12.62050281-7.45413779l0-97.63635483-165.08259105 0c-135.05673638 0-137.28489694-155.01877673-137.28489694-155.01877672 0 49.26460412 133.00343686 67.11240974 133.00343685 67.11240973l169.36404984 0 0-91.46321057c0 0 0.49809043-6.11883061 12.6205028-9.28753537 9.78695012-2.61100214 17.01191319 1.77908395 17.0119132 1.77908395l173.36997004 118.9880147c0 0 11.44945959 6.50829504 11.4494596 22.40745292C805.95510147 678.41524828 789.83074315 686.64169077 789.83074315 686.64169077z" p-id="764"></path></svg>',
      airSvg: '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg t="1513314660348" class="icon" style="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="776" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><defs><style type="text/css"></style></defs><path d="M882.19306667 684.68906667l0-67.8656-305.48479999-203.648-1e-8-237.568c0 0 0-67.8656-67.8656-67.8656-67.8912 0-67.8912 67.8656-67.8912 67.8656l-1e-8 237.568L135.49226667 616.82346667l0 67.8656 305.45919999-101.8368 1e-8 190.10560001-101.8112 81.45919999 0 67.8656 169.7024-67.86560001 169.7024 67.86560001 0-67.8656-101.83680001-81.4592 2e-8-190.1056L882.19306667 684.68906667z" p-id="777"></path></svg>'
    };
  },
  created: function created() {
    // 如皋开启了高清适配，获取dpr
    if (this.hd) {
      var ua = navigator.userAgent;
      var matches = ua.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
      var UCversion = ua.match(/U3\/((\d+|\.){5,})/i);
      var isUCHd = UCversion && parseInt(UCversion[1].split('.').join(''), 10) >= 80;
      var isIos = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
      var dpr = window.devicePixelRatio || 1;
      if (!isIos && !(matches && matches[1] > 534) && !isUCHd) {
        dpr = 1;
      }
      this.dpr = dpr;
    }
  },

  computed: {
    airPortLocations: function airPortLocations() {
      return this.codes.map(function (codeGroup) {
        return codeGroup.map(function (code) {
          return __WEBPACK_IMPORTED_MODULE_3__china_airport_location___default.a.find(function (l) {
            return l.airport === code;
          });
        }).filter(function (l) {
          return !!l;
        });
        // codeGroup.map(code => airPortLocation.find(l => l.airport === code)).filter(l => !!l)
      });
    }
  },
  mounted: function mounted() {
    this.drawLine();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.zr) {
      // 销毁地图
      this.zr.dispose();
    }
  },

  methods: {
    drawLine: function drawLine() {
      var _this = this;

      // 根据dpr缩放地图上的元素
      var dotR = this.dotR * this.dpr;
      var dotShadowBlur = this.dotShadowBlur * this.dpr;
      var iconSize = this.iconSize * this.dpr;
      var fontSize = 12 * this.dpr;

      var width = this.$el.clientWidth;
      var height = width * 2 / 3; // 长宽比  3:2
      // 初始化画布实例
      this.zr = __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.init(this.$el, { renderer: 'svg', width: width, height: height });
      // 初始化地图投影的工具类
      __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* init */](__WEBPACK_IMPORTED_MODULE_2__china___default.a, width, height);
      // 画中国地图
      __WEBPACK_IMPORTED_MODULE_1__utils__["c" /* drawChinaMap */](__WEBPACK_IMPORTED_MODULE_0_zrender___default.a, this.zr, { fill: this.mapFill, stroke: this.mapStroke });
      // 画航线
      this.airPortLocations.forEach(function (locations) {
        // 循环地标组
        locations.forEach(function (a, index, arr) {
          // 将经纬度转为画布上的坐标
          var p = __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* convert */](a.location.map(function (n) {
            return Number(n);
          }));
          // 画机场的点 // 中转机场画中转图标
          if (index === 0 || index === arr.length - 1) {
            var circle = new __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.Circle({
              shape: {
                cx: p[0],
                cy: p[1],
                r: dotR
              },
              style: {
                fill: _this.dotFill,
                text: a.city,
                fontSize: fontSize,
                textPosition: 'right',
                shadowColor: _this.dotFill,
                shadowBlur: dotShadowBlur
              },
              z: _this.dotZ
            });
            _this.zr.add(circle);
          } else {
            var zzIcon = __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.path.createFromString(_this.zzSvg, {
              style: {
                fill: _this.dotFill,
                text: a.city,
                fontSize: fontSize,
                textPosition: 'right'
              },
              z: _this.dotZ
            });
            // 缩放
            var size = dotR * 2;
            zzIcon.attr('scale', [size / 1024, size / 1024]);
            zzIcon.attr('position', [p[0] - size / 2, p[1] - size / 2]);
            _this.zr.add(zzIcon);
          }
          // 每2点间画线
          if (index < arr.length - 1) {
            var p2 = __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* convert */](arr[index + 1].location.map(function (n) {
              return Number(n);
            }));
            var zzLine = new __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.Line({
              shape: {
                x1: p[0],
                y1: p[1],
                x2: p2[0],
                y2: p2[1]
              },
              style: {
                stroke: _this.lineStroke
              },
              z: _this.lineZ
            });
            _this.zr.add(zzLine);
            // 画飞机图标
            // 通过svg图新建一个path
            var air = __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.path.createFromString(_this.airSvg, { style: { fill: _this.iconFill }, z: _this.iconZ });
            // 缩放
            air.attr('scale', [iconSize / 1024, iconSize / 1024]);
            // 航线角度
            var angle = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* angle */](p, p2, 90);
            // 根据航线方向旋转图标，让飞机头始终向着航向方向
            air.attr('rotation', Math.PI / 180 * angle);
            // 计算偏移
            var out = __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.matrix.create();
            __WEBPACK_IMPORTED_MODULE_0_zrender___default.a.matrix.rotate(out, [iconSize / 2, iconSize / 2], Math.PI / 180 * angle);
            // 计算图标的起点和终点
            var startPoint = [p[0] - iconSize / 2 + (iconSize / 2 - out[0]), p[1] - iconSize / 2 + (iconSize / 2 - out[1])];
            var endPoint = [p2[0] - iconSize / 2 + (iconSize / 2 - out[0]), p2[1] - iconSize / 2 + (iconSize / 2 - out[1])];
            // air.attr('position', [startPoint , endPoint])
            // 动画效果
            var long = _this.time + _this.timeStop * 2; // 一个航段的动画时长
            // 移动动画
            air.animate('position', true).when(0, startPoint).when(long * index, startPoint).when(_this.timeStop + long * index, startPoint).when(_this.timeStop + _this.time + long * index, endPoint).when(long * (arr.length - 1), endPoint).start();
            // 透明度动画，不飞行的飞机隐藏
            air.animate('style', true).when(0, { opacity: 0 }).when(long * index, { opacity: 0 }).when(_this.timeStop + long * index, { opacity: 1 }).when(_this.timeStop + _this.time + long * index, { opacity: 1 }).when(_this.timeStop * 2 + _this.time + long * index, { opacity: 0 }).when(long * (arr.length - 1), { opacity: 0 }).start();
            // 画svg图
            _this.zr.add(air);
          }
        });
      });
    }
  },
  watch: {
    codes: function codes(nval, oval) {
      this.zr.dispose();
      this.drawLine();
    }
  }
});

/***/ }),

/***/ "64zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AirScroll__ = __webpack_require__("bU+v");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirIndexList',
  components: { Scroll: __WEBPACK_IMPORTED_MODULE_3__AirScroll__["a" /* default */] },
  props: {
    data: {
      type: Array,
      required: true
    },
    hots: Array,
    hotHighlight: Array,
    hotHighlightClass: {
      type: String,
      default: 'air-index-select__key-hot-hl'
    },
    histories: Array,
    textField: {
      type: String,
      required: true
    },
    subTextField: String,
    groupField: {
      type: String,
      required: true
    },
    keyField: {
      type: String,
      required: true
    },
    searchHit: String,
    activeColor: {
      type: String,
      default: '#FF0000'
    },
    searchFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabs: Array,
    hotText: {
      type: String,
      default: '热'
    },
    hisText: {
      type: String,
      default: ''
    },
    searchClass: String,
    hotClass: String,
    indexClass: String,
    hisClass: String,
    fixTitle: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      tip: '', // 提示文字
      active: this.hisText || this.hotText, // index上面激活的文字
      titleDom: null,
      contentDom: null,
      showTip: false,
      titleOffsetTops: [],
      keyword: '',
      tabIndex: 0,
      offset: 0 // 下一个标题距离顶部位置
    };
  },
  created: function created() {
    // 排序
    this.sortedData();
  },

  computed: {
    index: function index() {
      var arr = [this.hotText].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.listData)));
      this.hisText && arr.unshift(this.hisText);
      return arr;
    },
    tabFilterData: function tabFilterData() {
      if (this.tabs) {
        return this.data[this.tabIndex];
      } else {
        return this.data;
      }
    },
    hotData: function hotData() {
      var _this = this;

      return this.hots.map(function (item) {
        return _this.tabFilterData.find(function (item2) {
          return item2[_this.keyField] === item;
        });
      }).filter(function (item) {
        return item;
      });
      // return this.tabFilterData.filter(item => this.hots.includes(item[this.keyField]))
    },
    hisData: function hisData() {
      var _this2 = this;

      if (this.histories && this.histories.length > 0) {
        // return this.tabFilterData.filter(item => this.histories.includes(item[this.keyField]))
        return this.histories.map(function (item) {
          return _this2.tabFilterData.find(function (item2) {
            return item2[_this2.keyField] === item;
          });
        }).filter(function (item) {
          return item;
        });
      }
      return [];
    },
    searchData: function searchData() {
      var _this3 = this;

      if (this.keyword) {
        return this.tabFilterData.filter(function (item) {
          return _this3.searchFields.some(function (f) {
            return item[f].toUpperCase().indexOf(_this3.keyword.toUpperCase()) > -1;
          });
        });
      }
      return this.tabFilterData;
    },
    listData: function listData() {
      var _this4 = this;

      var temp = {};
      this.searchData.forEach(function (item) {
        // 分组
        var key = item[_this4.groupField].charAt(0).toUpperCase();
        if (!temp[key]) {
          temp[key] = [];
        }
        temp[key].push(item);
      });
      this.$nextTick(function () {
        _this4.titleOffsetTops = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(_this4.$el.querySelectorAll('dt')).map(function (dt, index) {
          var text = dt.innerText;
          if (_this4.hisText) {
            if (index === 0) {
              text = _this4.hisText;
            } else if (index === 1) {
              text = _this4.hotText;
            }
          } else {
            if (index === 0) {
              text = _this4.hotText;
            }
          }
          return { char: text, y: dt.offsetTop };
        });
      });
      return temp;
    },
    titleStyle: function titleStyle() {
      return {
        transform: 'translate3d(0, ' + this.offset + 'px, 0)'
      };
    }
  },
  mounted: function mounted() {
    this.contentDom = this.$el.querySelector('.air-index-select__content');
    this.titleDom = this.$el.querySelector('.air-index-select__title');
    // this.titleOffsetTops = Array.from(this.$el.querySelectorAll('dt')).map(dt => ({dom: dt, char: dt.innerText, y: dt.offsetTop}))
  },

  methods: {
    sortedData: function sortedData() {
      var _this5 = this;

      if (this.tabs) {
        this.data.forEach(function (a) {
          return _this5.sortedArray(a);
        });
      } else {
        this.sortedArray(this.data);
      }
    },
    sortedArray: function sortedArray(arr) {
      var _this6 = this;

      arr.sort(function (item1, item2) {
        // 排序
        var key1 = item1[_this6.groupField].charAt(0).toUpperCase();
        var key2 = item2[_this6.groupField].charAt(0).toUpperCase();
        if (key1 > key2) {
          return 1;
        } else if (key1 < key2) {
          return -1;
        } else {
          return 0;
        }
      });
    },

    // 绑定索引条触摸事件
    touchstart: function touchstart(e) {
      this.moveIndex(e);
    },
    touchmove: function touchmove(e) {
      this.moveIndex(e);
    },
    touchend: function touchend() {
      this.showTip = false;
    },
    moveIndex: function moveIndex(e) {
      var point = e.changedTouches ? e.changedTouches[0] : e;
      // 找到点击的dom
      var pointElement = document.elementFromPoint(point.pageX, point.pageY);
      if (pointElement) {
        var char = pointElement.innerText;
        if (this.index.includes(char)) {
          var titleDom = this.$el.querySelector('.air-index-select__key-' + this.getChar(char));
          if (char && titleDom) {
            this.clickChar(char);
            this.showTip = true;
          }
        }
      }
    },
    getChar: function getChar(char) {
      if (char === this.hotText) {
        return 'hot';
      } else if (char === '历史') {
        return 'his';
      } else {
        return char;
      }
    },
    getHightLineClass: function getHightLineClass(key) {
      if (this.hotHighlight) return this.hotHighlight.find(function (item) {
        return item === key;
      }) ? this.hotHighlightClass : '';
    },
    clickChar: function clickChar(char) {
      this.tip = char;
      this.active = char;
    },
    scroll: function scroll(_ref) {
      var y = _ref.y;

      y = Math.abs(Math.min(y, 0));
      var dts = this.titleOffsetTops.filter(function (dt) {
        return dt.y - y <= 0;
      });
      if (dts && dts.length > 0) {
        this.active = dts[dts.length - 1].char;
      }
      // 下一个标题距离顶部的位置
      var h = Math.ceil(this.titleDom.clientHeight);
      var offset = this.titleOffsetTops[dts.length] ? this.titleOffsetTops[dts.length].y - y : h;
      this.offset = Math.min(Math.max(0, offset), h) - h;
    },
    clickItem: function clickItem(item) {
      this.$emit('on-selected', item);
    }
  },
  watch: {
    tip: function tip(char) {
      var titleDom = this.$el.querySelector('.air-index-select__key-' + this.getChar(char));
      if (titleDom) {
        this.$refs.scroll.scrollToElement(titleDom, 0);
      }
    },
    offset: function offset(val, oldVal) {
      if (val !== oldVal) {
        // this.titleDom.style.transform = `translate3d(0, ${val}px, 0)`
      }
    },
    data: function data(val, oldVal) {
      if (val !== oldVal) {
        this.sortedData();
      }
    }
  }
});

/***/ }),

/***/ "6jSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_AirAccordion__ = __webpack_require__("jMem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_AirAccordionContent__ = __webpack_require__("xhpN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_AirAccordion__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_AirAccordionContent__["a"]; });
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/11/15.
 */



__WEBPACK_IMPORTED_MODULE_0__src_AirAccordion__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_AirAccordion__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_AirAccordion__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__src_AirAccordionContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__src_AirAccordionContent__["a" /* default */]);
};

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__src_AirAccordion__["a" /* default */]);


/***/ }),

/***/ "7IlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_block_vue__ = __webpack_require__("beFg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b03925c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_block_vue__ = __webpack_require__("hXuJ");
function injectStyle (ssrContext) {
  __webpack_require__("zfcq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demo_block_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b03925c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_demo_block_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7yKk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "80zv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AirCalendarV_vue__ = __webpack_require__("ogF0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f74786b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AirCalendarV_vue__ = __webpack_require__("98yk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AirCalendarV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f74786b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AirCalendarV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8F9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header",style:(_vm.$route.name === 'index' ? 'box-shadow:none' : 'box-shadow:0 10px 60px 0 rgba(29,29,31,0.07)')},[_c('div',{staticClass:"header-container"},[_c('router-link',{attrs:{"to":{name: 'index'}}},[_c('img',{attrs:{"src":__webpack_require__("7yKk"),"width":"100"}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'giud'}}},[_vm._v("组件")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8rqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-calendar-h"},[_c('span',{staticClass:"air-calendar-h--left",class:{disable: _vm.disableLeft},on:{"click":_vm.pre}},[_vm._t("left",[_vm._v("<")])],2),_vm._v(" "),_c('div',[_c('div',{staticClass:"air-calendar-h--wrap",style:(_vm.transform)},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"air-calendar-h--item",class:{disable: item.disable, pre: i < _vm.index, next: i > _vm.index },on:{"click":function($event){_vm.clickItem(i)}}},[(i === _vm.index)?_c('div',{staticClass:"air-calendar-h--y"},[_vm._v(_vm._s(item.y)+"年")]):_c('div',{staticClass:"air-calendar-h--y"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"air-calendar-h--con"},[_c('div',{staticClass:"air-calendar-h--con2"},[_c('div',{staticClass:"air-calendar-h--date"},[(i === _vm.index || !_vm.preText || !_vm.nextText)?[_c('span',[_vm._v(_vm._s(item.m)+"-"+_vm._s(item.d))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.w))])]:[_c('span',[_vm._v(_vm._s(i < _vm.index ? _vm.preText : _vm.nextText))])]],2),_vm._v(" "),(item.text)?_c('div',{staticClass:"air-calendar-h--data"},[_vm._v(_vm._s(_vm.currency + item.text))]):_c('div',{staticClass:"air-calendar-h--data"},[_vm._v(" ")])]),_vm._v(" "),(_vm.$slots.icon)?_c('span',{staticClass:"air-calendar-h--icon"},[(i === _vm.index)?_vm._t("icon"):_vm._e()],2):_vm._e()])])})),_vm._v(" "),_c('div',{staticClass:"air-calendar-h--line"})]),_vm._v(" "),_c('span',{staticClass:"air-calendar-h--right",class:{disable: _vm.disableRight},on:{"click":_vm.next}},[_vm._t("right",[_vm._v(">")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8thI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirIndexSelect',
  props: {
    data: {
      type: Array,
      required: true
    },
    hots: Array,
    textField: {
      type: String,
      required: true
    },
    subTextField: String,
    groupField: {
      type: String,
      required: true
    },
    keyField: {
      type: String,
      required: true
    },
    searchHit: String,
    activeColor: {
      type: String,
      default: '#FF0000'
    },
    searchFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabs: Array
  },
  data: function data() {
    return {
      tip: '', // 提示文字
      active: '热', // index上面激活的文字
      contentDom: null,
      titleDom: null,
      showTip: false,
      titleOffsetTops: [],
      keyword: '',
      tabIndex: 0,
      offset: 0 // 下一个标题距离顶部位置
    };
  },
  created: function created() {
    // 排序
    this.sortedData();
  },

  computed: {
    index: function index() {
      return ['热'].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.listData)));
    },
    tabFilterData: function tabFilterData() {
      if (this.tabs) {
        return this.data[this.tabIndex];
      } else {
        return this.data;
      }
    },
    hotData: function hotData() {
      var _this = this;

      return this.tabFilterData.filter(function (item) {
        return _this.hots.includes(item[_this.keyField]);
      });
    },
    searchData: function searchData() {
      var _this2 = this;

      if (this.keyword) {
        return this.tabFilterData.filter(function (item) {
          return _this2.searchFields.some(function (f) {
            return item[f].toUpperCase().indexOf(_this2.keyword.toUpperCase()) > -1;
          });
        });
      }
      return this.tabFilterData;
    },
    listData: function listData() {
      var _this3 = this;

      var temp = {};
      this.searchData.forEach(function (item) {
        // 分组
        var key = item[_this3.groupField].charAt(0).toUpperCase();
        if (!temp[key]) {
          temp[key] = [];
        }
        temp[key].push(item);
      });
      this.$nextTick(function () {
        _this3.titleOffsetTops = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(_this3.$el.querySelectorAll('dt')).map(function (dt) {
          return { char: dt.innerText, y: dt.offsetTop };
        });
      });
      return temp;
    }
  },
  mounted: function mounted() {
    this.contentDom = this.$el.querySelector('.air-index-select__content');
    this.titleDom = this.$el.querySelector('.air-index-select__title');
    // this.titleOffsetTops = Array.from(this.$el.querySelectorAll('dt')).map(dt => ({char: dt.innerText, y: dt.offsetTop - this.contentDom.offsetTop}))
  },

  methods: {
    sortedData: function sortedData() {
      var _this4 = this;

      if (this.tabs) {
        this.data.forEach(function (a) {
          return _this4.sortedArray(a);
        });
      } else {
        this.sortedArray(this.data);
      }
    },
    sortedArray: function sortedArray(arr) {
      var _this5 = this;

      arr.sort(function (item1, item2) {
        // 排序
        var key1 = item1[_this5.groupField].charAt(0).toUpperCase();
        var key2 = item2[_this5.groupField].charAt(0).toUpperCase();
        if (key1 > key2) {
          return 1;
        } else if (key1 < key2) {
          return -1;
        } else {
          return 0;
        }
      });
    },

    // 绑定索引条触摸事件
    touchstart: function touchstart(e) {
      this.moveIndex(e);
    },
    touchmove: function touchmove(e) {
      this.moveIndex(e);
    },
    touchend: function touchend() {
      this.showTip = false;
    },
    moveIndex: function moveIndex(e) {
      var point = e.changedTouches ? e.changedTouches[0] : e;
      // 找到点击的dom
      var pointElement = document.elementFromPoint(point.pageX, point.pageY);
      if (pointElement) {
        var char = pointElement.innerText;
        if (this.index.includes(char)) {
          var titleDom = this.$el.querySelector('.air-index-select__key-' + (char === '热' ? 'hot' : char));
          if (char && titleDom && char.length === 1) {
            this.clickChar(char);
            this.showTip = true;
          }
        }
      }
    },
    clickChar: function clickChar(char) {
      this.tip = char;
      this.active = char;
    },
    scroll: function scroll() {
      var _this6 = this;

      var dts = this.titleOffsetTops.filter(function (dt) {
        return dt.y - _this6.contentDom.scrollTop <= _this6.contentDom.offsetTop;
      });
      if (dts && dts.length > 0) {
        this.active = dts[dts.length - 1].char.charAt(0);
      }
      // 下一个标题距离顶部的位置
      var offset = this.titleOffsetTops[dts.length] ? this.titleOffsetTops[dts.length].y - this.contentDom.scrollTop - this.contentDom.offsetTop : 26;
      // 这个值只能在0-26之间才触发位移  26为title的高
      this.offset = Math.min(Math.max(0, offset), 26) - 26;
    },
    clickItem: function clickItem(item) {
      this.$emit('on-selected', item);
    }
  },
  watch: {
    tip: function tip(char) {
      var titleDom = this.$el.querySelector('.air-index-select__key-' + (char === '热' ? 'hot' : char));
      if (titleDom) {
        this.contentDom.scrollTop = titleDom.offsetTop - this.contentDom.offsetTop;
      }
    },
    offset: function offset(val, oldVal) {
      if (val !== oldVal) {
        this.titleDom.style.transform = 'translate3d(0, ' + val + 'px, 0)';
      }
    }
  }
});

/***/ }),

/***/ "98yk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-calendar-v",class:'air-calendar-v__select'+_vm.select},[(_vm.double)?_c('div',{staticClass:"air-calendar-v--header"},_vm._l((_vm.titles),function(text,i){return _c('div',{class:{active:_vm.select === i + 1}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(text))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.activeDate1.format))])])})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"air-calendar-v--week",class:_vm.weekBg},_vm._l((_vm.weeks),function(w){return _c('span',[_vm._v(_vm._s(w))])})),_vm._v(" "),_c('div',{staticClass:"air-calendar-v--content"},_vm._l((_vm.renderList),function(month){return _c('div',{key:month.m,staticClass:"air-calendar-v--month"},[_c('div',{staticClass:"air-calendar-v--title"},[_c('span',[_vm._v(_vm._s(month.m))]),_vm._v(" "),_c('span',[_vm._v("月"+_vm._s(month.y)+"年")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(month.lowPrice && _vm.currency + month.lowPrice + '+'))])]),_vm._v(" "),_c('div',{staticClass:"air-calendar-v--days"},_vm._l((month.ds),function(date,index){return _c('span',{key:index,class:{
                disable:date.state === -1,
                low:date.low,
                null: !date,
                'is-area': _vm.isBefore && date.state >= 1 && date.state <= 3,
                active1: date.state === 1,
                active2: date.state === 3,
                weekend: date.w === 6 || date.w === 0
              },on:{"click":function($event){_vm.clickDate(month, date)}}},[(date.holiday)?_c('span',{staticClass:"holiday"},[_vm._v("￥"+_vm._s(date.holiday))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"day"},[_vm._v(_vm._s(date.d))]),_vm._v(" "),(_vm.isBefore && date.state >= 1 && date.state <= 3)?_c('span',{staticClass:"area"}):_vm._e(),_vm._v(" "),(date.price)?_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.currency + date.price))]):_vm._e()])}))])})),_vm._v(" "),(!_vm.double && _vm.activeDate1.date || _vm.isBefore)?_c('div',{staticClass:"air-calendar-v--btn",on:{"click":_vm.selected}},[_vm._t("btn",[_c('div',[_vm._v(_vm._s(_vm.btnText))])])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B0eO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_loading__ = __webpack_require__("qEhS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirDataBlock',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__common_loading__["a" /* default */] },
  props: {
    method: {
      type: Function,
      required: true
    },
    loadingText: {
      type: String,
      default: '加载中...'
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    errorText: {
      type: String,
      default: '出现异常, 点击重试'
    }
  },
  data: function data() {
    return {
      stateMap: {
        loading: -2,
        error: -1,
        empty: 0,
        ok: 1
      },
      state: -2
    };
  },
  created: function created() {
    this.loadData();
  },

  methods: {
    retry: function retry() {
      this.state === this.stateMap.error && this.loadData();
    },
    loadData: function loadData() {
      this.state = this.stateMap.loading;
      this.method && this.method(this.changeState);
    },
    changeState: function changeState() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      val = Math.min(this.stateMap.ok, val);
      this.state = val;
    }
  }
});

/***/ }),

/***/ "B5wG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("yyt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb3fd28c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("8F9g");
function injectStyle (ssrContext) {
  __webpack_require__("2Qfd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb3fd28c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BMRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"bubble",style:(_vm.style),attrs:{"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CkX9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_config__ = __webpack_require__("RfVA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_better_scroll__ = __webpack_require__("GQaK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PullDown_vue__ = __webpack_require__("VJiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_domUtils__ = __webpack_require__("FVDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_loading__ = __webpack_require__("qEhS");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var DIRECTION_H = 'horizontal';
var DIRECTION_V = 'vertical';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirScroll',
  props: {
    md: Boolean,
    data: {},
    noRoot: {
      type: Boolean,
      default: false
    },
    keepLocation: {
      type: Boolean,
      default: true
    },
    click: {
      type: Boolean,
      default: true
    },
    tap: {
      type: Boolean,
      default: true
    },
    probeType: {
      type: Number,
      default: 1
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    listenBeforeScroll: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: DIRECTION_V
    },
    scrollbar: {
      type: [Boolean, Object],
      default: true
    },
    pullDownRefresh: {
      type: [Boolean, Object],
      default: false
    },
    pullUpLoad: {
      type: [Boolean, Object],
      default: false
    },
    startY: {
      type: Number,
      default: 0
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    freeScroll: {
      type: Boolean,
      default: false
    },
    mouseWheel: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      beforePullDown: true,
      isRebounding: false,
      isPullingDown: false,
      isPullUpLoad: false,
      pullUpDirty: true,
      pullDownStyle: '',
      bubbleY: 0,
      loadError: false
    };
  },

  computed: {
    pullUpTxt: function pullUpTxt() {
      var moreTxt = this.pullUpLoad && this.pullUpLoad.moreText || '加载更多';
      var noMoreTxt = this.pullUpLoad && this.pullUpLoad.noMoreText || '没有更多数据';
      return this.pullUpDirty ? moreTxt : noMoreTxt;
    },
    refreshTxt: function refreshTxt() {
      var text = this.pullDownRefresh && this.pullDownRefresh.text || '刷新成功';
      var errText = this.pullDownRefresh && this.pullDownRefresh.errText || '刷新失败';
      return this.loadError ? errText : text;
    }
  },
  created: function created() {
    // this.pullDownInitTop = -50
  },
  mounted: function mounted() {
    var _this = this;

    this.pullDownInitTop = this.$refs.pulldown ? -this.$refs.pulldown.$el.clientHeight : 0;
    setTimeout(function () {
      _this.initScroll();
      _this.toKeepLocation();
    }, 20);
  },
  activated: function activated() {
    this.refresh();
    this.toKeepLocation();
  },
  deactivated: function deactivated() {
    // this.$route.meta.y = this.scroll.y
    // this.disable()
  },

  methods: {
    toKeepLocation: function toKeepLocation() {
      var _this2 = this;

      if (this.scroll) {
        var y = this.keepLocation && this.$route.meta && this.$route.meta.isBack && this.$route.meta.y || this.startY;
        this.$nextTick(function () {
          return _this2.scrollTo(0, y);
        });
      }
    },
    saveLocation: function saveLocation(pos) {
      this.$route.meta.y = pos.y;
    },
    initScroll: function initScroll() {
      var _this3 = this;

      if (!this.$refs.wrapper) {
        return;
      }
      // 如果开启了上拉和下拉刷新，处理内容不到一屏的时候，下拉上拉无效的问题
      if (this.$refs.listWrapper && (this.pullDownRefresh || this.pullUpLoad)) {
        this.$refs.listWrapper.style.minHeight = Object(__WEBPACK_IMPORTED_MODULE_4__utils_domUtils__["a" /* getRect */])(this.$refs.wrapper).height + 1 + 'px';
      }
      var options = {
        probeType: this.probeType,
        click: this.click,
        scrollY: this.freeScroll || this.direction === DIRECTION_V,
        scrollX: this.freeScroll || this.direction === DIRECTION_H,
        scrollbar: this.scrollbar,
        pullDownRefresh: this.pullDownRefresh === true ? { threshold: -this.pullDownInitTop, stop: -this.pullDownInitTop } : this.pullDownRefresh,
        pullUpLoad: this.pullUpLoad,
        startY: this.startY,
        freeScroll: this.freeScroll,
        mouseWheel: __WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */].mouseWheel || this.mouseWheel
      };

      this.scroll = new __WEBPACK_IMPORTED_MODULE_2_better_scroll__["a" /* default */](this.$refs.wrapper, options);

      if (this.listenScroll) {
        this.scroll.on('scroll', function (pos) {
          _this3.$emit('scroll', pos);
        });
      }

      if (this.keepLocation) {
        this.scroll.on('scrollEnd', this.saveLocation);
      }

      if (this.listenBeforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this3.$emit('beforeScrollStart');
        });
      }

      if (this.pullDownRefresh) {
        this._initPullDownRefresh();
      }

      if (this.pullUpLoad) {
        this._initPullUpLoad();
      }
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    },
    destroy: function destroy() {
      this.scroll.destroy();
    },
    forceUpdate: function forceUpdate(dirty) {
      var _this4 = this;

      if (this.pullDownRefresh && this.isPullingDown) {
        this.isPullingDown = false;
        this.loadError = !dirty;
        this.pullUpDirty = dirty;
        this._reboundPullDown().then(function () {
          _this4._afterPullDown();
        });
      } else if (this.pullUpLoad && this.isPullUpLoad) {
        this.isPullUpLoad = false;
        this.scroll.finishPullUp();
        this.pullUpDirty = dirty;
        this.refresh();
      } else {
        this.refresh();
      }
    },
    _initPullDownRefresh: function _initPullDownRefresh() {
      var _this5 = this;

      this.scroll.on('pullingDown', function () {
        _this5.beforePullDown = false;
        _this5.isPullingDown = true;
        _this5.$emit('pullingDown');
      });

      this.scroll.on('scroll', function (pos) {
        if (_this5.beforePullDown) {
          _this5.bubbleY = Math.max(0, pos.y + _this5.pullDownInitTop);
          _this5.pullDownStyle = Math.min(pos.y + _this5.pullDownInitTop, 0);
        } else {
          _this5.bubbleY = 0;
        }

        if (_this5.isRebounding) {
          _this5.pullDownStyle = 0 - (_this5.pullDownRefresh.stop - pos.y);
        }
        _this5.$route.meta.y = pos.y;
      });
    },
    _initPullUpLoad: function _initPullUpLoad() {
      var _this6 = this;

      this.scroll.on('pullingUp', function () {
        _this6.isPullUpLoad = true;
        _this6.$emit('pullingUp');
      });
    },
    _reboundPullDown: function _reboundPullDown() {
      var _this7 = this;

      var _pullDownRefresh$stop = this.pullDownRefresh.stopTime,
          stopTime = _pullDownRefresh$stop === undefined ? 600 : _pullDownRefresh$stop;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(function () {
          _this7.isRebounding = true;
          _this7.scroll.finishPullDown();
          resolve();
        }, stopTime);
      });
    },
    _afterPullDown: function _afterPullDown() {
      var _this8 = this;

      setTimeout(function () {
        _this8.pullDownStyle = _this8.pullDownInitTop;
        _this8.beforePullDown = true;
        _this8.isRebounding = false;
        _this8.refresh();
      }, this.md ? 0 : this.scroll.options.bounceTime);
    }
  },
  watch: {
    data: function data() {
      var _this9 = this;

      this.$nextTick(function () {
        return _this9.forceUpdate(true);
      });
    }
  },
  components: { Loading: __WEBPACK_IMPORTED_MODULE_5__common_loading__["a" /* default */], PullDown: __WEBPACK_IMPORTED_MODULE_3__PullDown_vue__["a" /* default */] }
});

/***/ }),

/***/ "F/Gm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_AirLineMap_vue__ = __webpack_require__("2RCn");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/11/15.
 */


__WEBPACK_IMPORTED_MODULE_0__src_AirLineMap_vue__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_AirLineMap_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_AirLineMap_vue__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_AirLineMap_vue__["a" /* default */]);

/***/ }),

/***/ "FVDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasClass */
/* unused harmony export addClass */
/* unused harmony export removeClass */
/* unused harmony export getData */
/* harmony export (immutable) */ __webpack_exports__["a"] = getRect;
function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className);
}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  var newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}

function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return;
  }

  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g');
  el.className = el.className.replace(reg, ' ');
}

function getData(el, name, val) {
  var prefix = 'data-';
  if (val) {
    return el.setAttribute(prefix + name, val);
  }
  return el.getAttribute(prefix + name);
}

function getRect(el) {
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

/***/ }),

/***/ "Fw4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__freeGlobal_js__ = __webpack_require__("VUwS");



/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(self)) == 'object' && self !== null && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_1__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);

/***/ }),

/***/ "HmY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__ = __webpack_require__("d6Ob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__ = __webpack_require__("GCGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_esm_isBefore__ = __webpack_require__("Yo08");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_esm_locale__ = __webpack_require__("V4rL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_throttle__ = __webpack_require__("sjmi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirCalendarH',
  props: {
    startDate: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    endDate: Date,
    value: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    nextText: String,
    preText: String,
    clickEnable: Boolean,
    currency: {
      type: String,
      default: '￥'
    }
  },
  data: function data() {
    return {
      // activeDate: this.value,
      list: [],
      index: 4, // 激活的日期的索引
      noAnim: false // 不要动画，用于移动到边界的时候，瞬间调整位置
    };
  },

  computed: {
    activeDate: function activeDate() {
      return this.list.length > 0 ? this.list[this.index].date : this.value;
    },
    transform: function transform() {
      return {
        transition: this.noAnim ? 'none' : 'all 0.3s',
        transform: 'translate3d(' + -33.33333 * (this.index - 1) + '%,0,0)'
      };
    },
    disableLeft: function disableLeft() {
      // 开始时间不在激活时间前，禁用后退
      return this.startDate && !Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_isBefore__["a" /* default */])(this.startDate, this.list[this.index].date);
    },
    disableRight: function disableRight() {
      // 激活时间不在结束时间前，禁用前进
      return this.endDate && !Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_isBefore__["a" /* default */])(this.list[this.index].date, this.endDate);
    }
  },
  watch: {
    activeDate: function activeDate(val, oldVal) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(val, 'YYYYMMDD') !== Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(oldVal, 'YYYYMMDD')) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    // 初始化要显示的日期数组
    init: function init() {
      // 通过激活的日期，生成前后2天，共5天的数据
      // 例如当前激活的日期是22日，那么生成前后5天的日期，[20,21,22,23,24]
      // 假如按照这样的5天一直循环，结构应该是这样[20,21,22,23,24,20,21,22,23,24,20,21,22,23,24,20,21,22,23,24.......]
      // 要实现无限循环，中间取一个完整循环的5天，前面取上一个循环的后2天，后面取下一个循环的前2天
      // 最终结果应该是这样的结构[23,24,20,21,22,23,24,20,21]
      var temp1 = [this.createItem(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__["a" /* default */])(this.activeDate, -2)), this.createItem(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__["a" /* default */])(this.activeDate, -1))];
      var temp2 = [this.createItem(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__["a" /* default */])(this.activeDate, 1)), this.createItem(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__["a" /* default */])(this.activeDate, 2))];
      this.list = [].concat(temp2, temp1, [this.createItem(this.activeDate)], temp2, temp1);
    },
    createItem: function createItem(date) {
      var disable = this.startDate && Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'YYYYMMDD') - Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(this.startDate, 'YYYYMMDD') < 0 || this.endDate && Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'YYYYMMDD') - Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(this.endDate, 'YYYYMMDD') > 0;
      var y = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'YYYY');
      var m = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'MM');
      var d = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'DD');
      var w = Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'ddd', { locale: __WEBPACK_IMPORTED_MODULE_3_date_fns_esm_locale__["a" /* zhCN */] });
      // 获取数据
      var item = this.data.find(function (d) {
        return d.date === Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm_format__["a" /* default */])(date, 'YYYY-MM-DD');
      });
      var text = item ? item.text : '';
      return { date: date, y: y, m: m, d: d, w: w, disable: disable, text: text };
    },

    // 这里使用节流的方式，保证在过渡动画完成前不触发下一次动画
    next: Object(__WEBPACK_IMPORTED_MODULE_4__utils_throttle__["a" /* default */])(function () {
      var _this = this;

      if (this.disableRight) {
        return;
      }
      // 到达边界，瞬间跳到前面的相同位置
      if (this.index >= 7) {
        this.noAnim = true;
        this.index = 2;
      }
      // 这里使用$nextTick和setTimeout都是为了保证前面的瞬间跳动的代码完成后才执行下面的更新
      // 只使用$nextTick不能完全保证，所以结合setTimeout一起使用
      this.$nextTick(function () {
        return setTimeout(function () {
          return _this.updateList(false);
        }, 0);
      });
    }, 350),
    pre: Object(__WEBPACK_IMPORTED_MODULE_4__utils_throttle__["a" /* default */])(function () {
      var _this2 = this;

      if (this.disableLeft) {
        return;
      }
      // 到达边界，瞬间调到后面的相同位置
      if (this.index <= 1) {
        this.noAnim = true;
        this.index = 6;
      }
      this.$nextTick(function () {
        return setTimeout(function () {
          return _this2.updateList();
        }, 0);
      });
    }, 350),
    updateList: function updateList() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // 更新集合
      this.noAnim = false;
      if (!left) {
        // 右移
        this.index++;
        // 右移的时候，先将当期激活的时间+2天
        var item = this.createItem(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__["a" /* default */])(this.list[this.index].date, 2));
        // 计算要更新的2个位置
        var i1 = this.index + 2;
        var i2 = this.index - 3;
        // 如果位置没有越界，就更新相应位置的数据
        i1 < this.list.length && this.list.splice(i1, 1, item);
        i2 >= 0 && this.list.splice(i2, 1, item);
      } else {
        // 左移
        this.index--;
        // 左移的时候，先将当期激活的时间-2天
        var _item = this.createItem(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns_esm_addDays__["a" /* default */])(this.list[this.index].date, -2));
        // 计算要更新的2个位置
        var _i = this.index - 2;
        var _i2 = this.index + 3;
        // 如果位置没有越界，就更新相应位置的数据
        _i2 < this.list.length && this.list.splice(_i2, 1, _item);
        _i >= 0 && this.list.splice(_i, 1, _item);
      }
    },

    clickItem: Object(__WEBPACK_IMPORTED_MODULE_4__utils_throttle__["a" /* default */])(function (i) {
      if (this.clickEnable) {
        if (i > this.index) {
          this.next();
        } else if (i < this.index) {
          this.pre();
        }
      }
      // 激活的日期点击事件
      if (this.index === i) {
        this.$emit('click', this.list[this.index].date);
      }
    }, 350)
  }
});

/***/ }),

/***/ "I1MJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AirCalendarH_vue__ = __webpack_require__("HmY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b49bd27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AirCalendarH_vue__ = __webpack_require__("8rqz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AirCalendarH_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b49bd27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AirCalendarH_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J6+S":
/***/ (function(module, exports) {

module.exports = [{"city":"阿克苏","airport":"AKU","isCapital":false,"location":["80.27555","41.18356"]},{"city":"阿勒泰","isCapital":false,"airport":"AAT","location":["88.12673","47.83278"]},{"city":"安康","isCapital":false,"airport":"AKA","location":["109.01464","32.70248"]},{"city":"鞍山","isCapital":false,"airport":"AOG","location":["123.00039","41.12520"]},{"city":"安庆","isCapital":false,"airport":"AQG","location":["117.05862","30.54287"]},{"city":"澳门","isCapital":true,"airport":"MFM","location":["113.54710","22.20447"]},{"city":"北京","isCapital":true,"airport":"PEK","location":["116.42275","39.91876"]},{"city":"保山","isCapital":false,"airport":"BSD","location":["99.17182","25.14693"]},{"city":"包头","isCapital":false,"airport":"BAV","location":["109.84158","40.66867"]},{"city":"北海","isCapital":false,"airport":"BHY","location":["109.12603","21.49099"]},{"city":"长白山","isCapital":false,"airport":"NBS","location":["127.61586","42.07438"]},{"city":"昌都","isCapital":false,"airport":"BPX","location":["97.17120","31.15219"]},{"city":"长春","isCapital":true,"airport":"CGQ","location":["125.31867","43.82948"]},{"city":"常德","isCapital":false,"airport":"CGD","location":["111.69522","29.04757"]},{"city":"长沙","isCapital":true,"airport":"CSX","location":["112.92866","28.26986"]},{"city":"长治","isCapital":false,"airport":"CIH","location":["112.92866","28.26986"]},{"city":"常州","isCapital":false,"airport":"CZX","location":["119.98589","31.84452"]},{"city":"朝阳","isCapital":false,"airport":"CHG","location":["120.45270","41.59783"]},{"city":"成都","isCapital":true,"airport":"CTU","location":["104.03614","30.60487"]},{"city":"赤峰","isCapital":false,"airport":"CIF","location":["118.84257","42.33565"]},{"city":"重庆","isCapital":true,"airport":"CKG","location":["106.49909","29.63204"]},{"city":"大理","isCapital":false,"airport":"DLU","location":["100.23742","25.61088"]},{"city":"大连","isCapital":false,"airport":"DLC","location":["121.61334","38.91822"]},{"city":"大同","isCapital":false,"airport":"DAT","location":["113.36278","40.11057"]},{"city":"丹东","isCapital":false,"airport":"DDG","location":["124.32059","40.02182"]},{"city":"达县","isCapital":false,"airport":"DAX","location":["107.47835","31.22084"]},{"city":"德宏芒市","isCapital":false,"airport":"LUM","location":["98.53847","24.4056"]},{"city":"迪庆","isCapital":false,"airport":"DIG","location":["99.68705","27.79586"]},{"city":"东营","isCapital":false,"airport":"DOY","location":["118.66034","37.46497"]},{"city":"敦煌","isCapital":false,"airport":"DNH","location":["94.67989","40.15166"]},{"city":"恩施","isCapital":false,"airport":"ENH","location":["109.48630","30.30513"]},{"city":"东胜","isCapital":false,"airport":"DSN","location":["109.87311","39.50183"]},{"city":"福州","isCapital":true,"airport":"FOC","location":["119.30121","26.09161"]},{"city":"阜阳","isCapital":false,"airport":"FUG","location":["115.8110","32.90000"]},{"city":"广州","isCapital":true,"airport":"CAN","location":["113.26561","23.13982"]},{"city":"广元","isCapital":false,"airport":"GYS","location":["105.84769","32.4522"]},{"city":"广汉","isCapital":false,"airport":"GHN","location":["104.33118","30.95142"]},{"city":"赣州","isCapital":false,"airport":"KOW","location":["114.93953","25.84108"]},{"city":"格尔木","isCapital":false,"airport":"GOQ","location":["94.93159","36.41486"]},{"city":"桂林","isCapital":false,"airport":"KWL","location":["110.17858","25.24355"]},{"city":"贵阳","isCapital":true,"airport":"KWE","location":["106.62646","26.67831"]},{"city":"哈尔滨","isCapital":true,"airport":"HRB","location":["126.52861","45.80396"]},{"city":"哈密","isCapital":false,"airport":"HMI","location":["93.53151","42.84243"]},{"city":"海口","isCapital":true,"airport":"HAK","location":["110.2012","20.06010"]},{"city":"邯郸","isCapital":false,"airport":"HDG","location":["114.54120","36.67175"]},{"city":"汉中","isCapital":false,"airport":"HZG","location":["107.02789","33.07454"]},{"city":"杭州","isCapital":true,"airport":"HGH","location":["120.13812","30.34017"]},{"city":"合肥","isCapital":true,"airport":"HFE","location":["117.22107","31.83987"]},{"city":"和田","isCapital":false,"airport":"HTN","location":["79.94727","37.11526"]},{"city":"黑河","isCapital":false,"airport":"HEK","location":["127.32357","50.18212"]},{"city":"衡阳","isCapital":false,"airport":"HNY","location":["112.56919","26.90596"]},{"city":"呼和浩特","isCapital":true,"airport":"HET","location":["111.75219","40.85379"]},{"city":"怀化","isCapital":false,"airport":"HJJ","location":["110.00524","27.58251"]},{"city":"黄果树","isCapital":false,"airport":"AVA","location":["105.88372","26.26280"]},{"city":"黄山","isCapital":false,"airport":"TXN","location":["118.26735","29.73612"]},{"city":"黄岩","isCapital":false,"airport":"HYN","location":["121.43758","28.56514"]},{"city":"惠阳","isCapital":false,"airport":"AHE","location":["114.68714","22.58202"]},{"city":"吉林","isCapital":false,"airport":"JIL","location":["126.54342","43.86285"]},{"city":"吉安","isCapital":false,"airport":"KNC","location":["114.99959","27.13260"]},{"city":"济南","isCapital":true,"airport":"TNA","location":["117.10767","36.68806"]},{"city":"济宁","isCapital":false,"airport":"JNG","location":["116.56798","35.44779"]},{"city":"佳木斯","isCapital":false,"airport":"JMU","location":["130.32121","46.80914"]},{"city":"嘉峪关","isCapital":false,"airport":"JGN","location":["98.29536","39.78824"]},{"city":"九寨沟","isCapital":false,"airport":"JZH","location":["103.69154","32.85731"]},{"city":"锦州","isCapital":false,"airport":"JNZ","location":["121.14455","41.12543"]},{"city":"景德镇","isCapital":false,"airport":"JDZ","location":["117.18209","29.28013"]},{"city":"荆州","isCapital":false,"airport":"SHS","location":["112.24434","30.35082"]},{"city":"九江","isCapital":false,"airport":"JIU","location":["116.00224","29.71810"]},{"city":"喀什","isCapital":false,"airport":"KHG","location":["76.00544","39.48109"]},{"city":"克拉玛依","isCapital":false,"airport":"KRY","location":["84.88897","45.59242"]},{"city":"喀纳斯","isCapital":false,"airport":"KJI","location":["87.00713","48.22942"]},{"city":"库尔勒","isCapital":false,"airport":"KRL","location":["86.18180","41.73541"]},{"city":"库车","isCapital":false,"airport":"KCA","location":["82.97098","41.72906"]},{"city":"昆明","isCapital":true,"airport":"KMG","location":["102.81782","24.91925"]},{"city":"拉萨","isCapital":true,"airport":"LXA","location":["91.11470","29.66188"]},{"city":"兰州","isCapital":true,"airport":"LHW","location":["103.83781","36.06847"]},{"city":"丽江","isCapital":false,"airport":"LJG","location":["100.23242","26.86432"]},{"city":"荔波","isCapital":false,"airport":"LLB","location":["107.89200","25.41988"]},{"city":"连云港","isCapital":false,"airport":"LYG","location":["119.2014","34.64535"]},{"city":"梁平","isCapital":false,"airport":"LIA","location":["107.80946","30.68474"]},{"city":"临沂","isCapital":false,"airport":"LYI","location":["118.36126","35.11312"]},{"city":"临沧","isCapital":false,"airport":"LNJ","location":["100.03216","23.74213"]},{"city":"柳州","isCapital":false,"airport":"LZH","location":["109.41163","24.36233"]},{"city":"泸州","isCapital":false,"airport":"LZO","location":["105.45254","28.89452"]},{"city":"洛阳","isCapital":false,"airport":"LYA","location":["112.46578","34.62508"]},{"city":"满洲里","isCapital":false,"airport":"NZH","location":["117.49000","49.59846"]},{"city":"梅县","isCapital":false,"airport":"MXZ","location":["116.10895","24.26561"]},{"city":"漠河","isCapital":false,"airport":"OHE","location":["122.54735","52.98159"]},{"city":"绵阳","isCapital":false,"airport":"MIG","location":["104.68788","31.48888"]},{"city":"牡丹江","isCapital":false,"airport":"MDG","location":["129.63495","44.57734"]},{"city":"那拉提","isCapital":false,"airport":"NLT","location":["83.38782","43.43922"]},{"city":"南昌","isCapital":true,"airport":"KHN","location":["115.83578","28.72746"]},{"city":"南充","isCapital":false,"airport":"NAO","location":["106.09653","30.87231"]},{"city":"南京","isCapital":true,"airport":"NKG","location":["118.77989","32.09728"]},{"city":"南宁","isCapital":true,"airport":"NNG","location":["108.32333","22.90269"]},{"city":"南通","isCapital":false,"airport":"NTG","location":["120.88937","32.02614"]},{"city":"南阳","isCapital":false,"airport":"NNY","location":["112.51143","33.03569"]},{"city":"宁波","isCapital":false,"airport":"NGB","location":["121.53598","29.91549"]},{"city":"攀枝花","isCapital":false,"airport":"PZI","location":["101.71951","26.59095"]},{"city":"齐齐哈尔","isCapital":false,"airport":"NDG","location":["123.89233","47.39582"]},{"city":"且末","isCapital":false,"airport":"IQM","location":["85.53970","38.15023"]},{"city":"青岛","isCapital":false,"airport":"TAO","location":["120.38542","36.07492"]},{"city":"庆阳","isCapital":false,"airport":"IQN","location":["107.64643","35.71961"]},{"city":"秦皇岛","isCapital":false,"airport":"BPE","location":["119.60790","39.94988"]},{"city":"衢州","isCapital":false,"airport":"JUZ","location":["118.86179","28.97579"]},{"city":"泉州","isCapital":false,"airport":"JJN","location":["118.67714","24.87788"]},{"city":"上海","isCapital":true,"airport":"SHA","location":["121.45609","31.27507"]},{"city":"上海","isCapital":false,"airport":"PVG","location":["121.45609","31.27507"]},{"city":"三亚","isCapital":false,"airport":"SYX","location":["109.51577","18.26343"]},{"city":"韶关","isCapital":false,"airport":"SHG","location":["113.61525","24.88725"]},{"city":"汕头","isCapital":false,"airport":"SWA","location":["117.51201","23.11568"]},{"city":"沈阳","isCapital":true,"airport":"SHE","location":["123.43437","41.86314"]},{"city":"深圳","isCapital":false,"airport":"SZX","location":["114.05288","22.58776"]},{"city":"泗水","isCapital":false,"airport":"SUB","location":["117.25629","35.67639"]},{"city":"鄯善","isCapital":false,"airport":"SXJ","location":["90.21588","42.87725"]},{"city":"思茅","isCapital":false,"airport":"SYM","location":["100.96682","22.79683"]},{"city":"石家庄","isCapital":true,"airport":"SJW","location":["114.49840","38.04618"]},{"city":"塔城","isCapital":false,"airport":"TCG","location":["82.98502","46.76017"]},{"city":"太原","isCapital":true,"airport":"TYN","location":["112.49956","37.90354"]},{"city":"天津","isCapital":true,"airport":"TSN","location":["117.21741","39.12069"]},{"city":"铜仁","isCapital":false,"airport":"TEN","location":["109.18695","27.76060"]},{"city":"万州","isCapital":false,"airport":"WXN","location":["108.41356","30.81387"]},{"city":"潍坊","isCapital":false,"airport":"WEF","location":["119.16641","36.71853"]},{"city":"威海","isCapital":false,"airport":"WEH","location":["122.08685","37.56533"]},{"city":"文山","isCapital":false,"airport":"WNH","location":["104.23023","23.38534"]},{"city":"温州","isCapital":false,"airport":"WNZ","location":["120.69609","28.00492"]},{"city":"梧州","isCapital":false,"airport":"WUZ","location":["111.26725","23.49480"]},{"city":"武汉","isCapital":true,"airport":"WUH","location":["114.28596","30.64641"]},{"city":"乌鲁木齐","isCapital":true,"airport":"URC","location":["87.57329","43.85839"]},{"city":"无锡","isCapital":false,"airport":"WUX","location":["120.31090","31.50089"]},{"city":"武夷山","isCapital":false,"airport":"WYS WUS","location":["118.01114","27.70365"]},{"city":"西昌","isCapital":false,"airport":"XIC","location":["102.27297","27.89779"]},{"city":"西安","isCapital":true,"airport":"XIY","location":["108.92503","34.37628"]},{"city":"西宁","isCapital":true,"airport":"XNN","location":["101.76989","36.62556"]},{"city":"西双版纳","isCapital":false,"airport":"JHG","location":["100.77078","21.97794"]},{"city":"厦门","isCapital":false,"airport":"XMN","location":["118.09016","24.49292"]},{"city":"锡林浩特","isCapital":false,"airport":"XIL","location":["116.09384","43.93851"]},{"city":"兴义","isCapital":false,"airport":"ACX","location":["104.90773","25.09892"]},{"city":"徐州","isCapital":false,"airport":"XUZ","location":["117.28142","34.22423"]},{"city":"襄阳","isCapital":false,"airport":"XFN","location":["112.13943","32.02679"]},{"city":"香港","isCapital":true,"airport":"HKG","location":["114.15014","22.38138"]},{"city":"盐城","isCapital":false,"airport":"YNZ","location":["120.15783","33.36470"]},{"city":"延安","isCapital":false,"airport":"ENY","location":["109.48716","36.60421"]},{"city":"延吉","isCapital":false,"airport":"YNJ","location":["129.46267","42.88967"]},{"city":"烟台","isCapital":false,"airport":"YNT","location":["121.43947","37.47467"]},{"city":"宜宾","isCapital":false,"airport":"YBP","location":["104.64005","28.79281"]},{"city":"宜昌","isCapital":false,"airport":"YIH","location":["111.28722","30.71722"]},{"city":"伊宁","isCapital":false,"airport":"YIN","location":["81.53967","43.98441"]},{"city":"义乌","isCapital":false,"airport":"YIW","location":["120.08241","29.31006"]},{"city":"永州","isCapital":false,"airport":"LLF","location":["111.60778","26.44239"]},{"city":"榆林","isCapital":false,"airport":"UYN","location":["109.73314","38.32735"]},{"city":"运城","isCapital":false,"airport":"YCU","location":["111.00648","35.05457"]},{"city":"银川","isCapital":true,"airport":"INC","location":["106.12514","38.62669"]},{"city":"湛江","isCapital":false,"airport":"ZHA","location":["110.36032","21.35878"]},{"city":"昭通","isCapital":false,"airport":"ZAT","location":["103.73710","27.37152"]},{"city":"张家界","isCapital":false,"airport":"DYG","location":["110.46480","29.14897"]},{"city":"郑州","isCapital":true,"airport":"CGO","location":["113.51176","34.85663"]},{"city":"舟山","isCapital":false,"airport":"HSN","location":["122.20744","29.99734"]},{"city":"珠海","isCapital":false,"airport":"ZUH","location":["113.57806","22.28308"]},{"city":"遵义","isCapital":false,"airport":"ZYI","location":["106.93135","27.73405"]},{"city":"黎平","isCapital":false,"airport":"HZH","location":["109.14202","26.24035"]},{"city":"大庆","isCapital":false,"airport":"DQA","location":["125.10570","46.59658"]},{"city":"伊春","isCapital":false,"airport":"LDS","location":["128.84934","47.77113"]},{"city":"台北","isCapital":true,"airport":"TPE","location":["121.53004","25.06810"]},{"city":"腾冲","isCapital":false,"airport":"TCZ","location":["98.48826","25.03937"]},{"city":"博乐","isCapital":false,"airport":"BPL","location":["82.05702","44.86253"]},{"city":"海拉尔","isCapital":false,"airport":"HLD","location":["119.83302","49.21928"]},{"city":"台中","isCapital":false,"airport":"RMQ","location":["120.66666","24.25"]},{"city":"扬州","isCapital":false,"airport":"YTY","location":["119.41680","32.43472"]},{"city":"毕节","isCapital":false,"airport":"BFJ","location":["105.28560","27.29587"]},{"city":"池州","isCapital":false,"airport":"JUH","location":["117.46736","30.68017"]},{"city":"井冈山","isCapital":false,"airport":"JGS","location":["114.28976","26.75610"]},{"city":"鸡西","isCapital":false,"airport":"JXA","location":["130.97213","45.30841"]},{"city":"黔江","isCapital":false,"airport":"JIQ","location":["108.77415","29.54477"]},{"city":"通辽","isCapital":false,"airport":"TGO","location":["122.24775","43.67526"]},{"city":"乌兰浩特","isCapital":false,"airport":"HLH","location":["122.01599","46.20403"]},{"city":"吕梁","isCapital":false,"airport":"LLV","location":["111.14406","37.52707"]},{"city":"通化","isCapital":false,"airport":"TNH","location":["125.94363","41.73412"]},{"city":"吐鲁番","isCapital":false,"airport":"TLQ","location":["89.20350","42.94484"]},{"city":"抚远","isCapital":false,"airport":"FYJ","location":["134.31673","48.37070"]},{"city":"林芝","isCapital":false,"airport":"LZY","location":["94.36489","29.64015"]},{"city":"富蕴","isCapital":false,"airport":"FYN","location":["89.53073","47.00164"]},{"city":"凯里","isCapital":false,"airport":"KJH","location":["107.99031","26.56985"]},{"city":"日照","isCapital":false,"airport":"RIZ","location":["119.33442","35.40594"]},{"city":"石河子","isCapital":false,"airport":"SHF","location":["86.09183","44.31097"]},{"city":"武当山","isCapital":false,"airport":"WDS","location":["110.91021","32.59591"]},{"city":"临汾","isCapital":false,"airport":"LFQ","location":["111.52212","36.14373"]},{"city":"忻州","isCapital":false,"airport":"WUT","location":["112.74080","38.43888"]},{"city":"加格达奇","isCapital":false,"airport":"JGD","location":["124.13109","50.38039"]},{"city":"天水","isCapital":false,"airport":"THQ","location":["105.72725","34.59690"]}]

/***/ }),

/***/ "JJYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue__ = __webpack_require__("B5wG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_vue__ = __webpack_require__("m4Eu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_side_nav_vue__ = __webpack_require__("wezC");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isIndex: true
    };
  },

  watch: {
    $route: function $route() {
      this.isIndex = this.$route.name === 'index';
    }
  },
  components: {
    mainHeader: __WEBPACK_IMPORTED_MODULE_0__components_header_vue__["a" /* default */],
    sideNav: __WEBPACK_IMPORTED_MODULE_2__components_side_nav_vue__["a" /* default */],
    mainFooter: __WEBPACK_IMPORTED_MODULE_1__components_footer_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "JiD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("LfK9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("Fw4R");



/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked, or until the next browser frame is drawn. The debounced function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * debounced function. Subsequent calls to the debounced function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `debounce` and `throttle`.
 *
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0]
 *  The number of milliseconds to delay; if omitted, `requestAnimationFrame` is
 *  used (if available).
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', debounce(calculateLayout, 150))
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }))
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * const debounced = debounce(batchLog, 250, { 'maxWait': 1000 })
 * const source = new EventSource('/stream')
 * jQuery(source).on('message', debounced)
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel)
 *
 * // Check for pending invocations.
 * const status = debounced.pending() ? "Pending..." : "Ready"
 */
function debounce(func, wait, options) {
  var lastArgs = void 0,
      lastThis = void 0,
      maxWait = void 0,
      result = void 0,
      timerId = void 0,
      lastCallTime = void 0;

  var lastInvokeTime = 0;
  var leading = false;
  var maxing = false;
  var trailing = true;

  // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
  var useRAF = !wait && wait !== 0 && typeof __WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */].requestAnimationFrame === 'function';

  if (typeof func != 'function') {
    throw new TypeError('Expected a function');
  }
  wait = +wait || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs;
    var thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function startTimer(pendingFunc, wait) {
    if (useRAF) {
      return __WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */].requestAnimationFrame(pendingFunc);
    }
    return setTimeout(pendingFunc, wait);
  }

  function cancelTimer(id) {
    if (useRAF) {
      return __WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */].cancelAnimationFrame(id);
    }
    clearTimeout(id);
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = startTimer(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime;
    var timeSinceLastInvoke = time - lastInvokeTime;
    var timeWaiting = wait - timeSinceLastCall;

    return maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime;
    var timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = startTimer(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      cancelTimer(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function pending() {
    return timerId !== undefined;
  }

  function debounced() {
    var time = Date.now();
    var isInvoking = shouldInvoke(time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = startTimer(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = startTimer(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  debounced.pending = pending;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),

/***/ "KnPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideAction_vue__ = __webpack_require__("0kyz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_201968d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideAction_vue__ = __webpack_require__("qD8K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_201968d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LLUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataBlock_vue__ = __webpack_require__("B0eO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af9afd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataBlock_vue__ = __webpack_require__("1YUc");
function injectStyle (ssrContext) {
  __webpack_require__("kw13")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0af9afd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af9afd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LfK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * isObject({})
 * // => true
 *
 * isObject([1, 2, 3])
 * // => true
 *
 * isObject(Function)
 * // => true
 *
 * isObject(null)
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);

/***/ }),

/***/ "Lneg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_AirCalendarV__ = __webpack_require__("80zv");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/01/22.
 */


__WEBPACK_IMPORTED_MODULE_0__src_AirCalendarV__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_AirCalendarV__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_AirCalendarV__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_AirCalendarV__["a" /* default */]);

/***/ }),

/***/ "NwlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_config_json__ = __webpack_require__("ffz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__nav_config_json__);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var routes = [];

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__nav_config_json___default.a).forEach(function (header) {
  routes = routes.concat(__WEBPACK_IMPORTED_MODULE_3__nav_config_json___default.a[header]);
});

var addComponent = function addComponent(router) {
  router.forEach(function (route) {
    if (route.items) {
      addComponent(route.items);
      routes = routes.concat(route.items);
    } else {
      if (route.type === 'pages') {
        route.component = function (r) {
          return __webpack_require__.e/* require.ensure */(1).then((function () {
            return r(__webpack_require__("LFUG")("./" + route.name + '.vue'));
          }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
        };
        return;
      }
      route.component = function (r) {
        return __webpack_require__.e/* require.ensure */(0).then((function () {
          return r(__webpack_require__("Gv6s")("./" + route.name + '.md'));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      };
    }
  });
};
addComponent(routes);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),

/***/ "ONGs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qy8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RWRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirSlideActionGroup',
  created: function created() {
    var _this = this;

    this.$on('slide-start', function () {
      return _this.reset();
    });
  },

  methods: {
    reset: function reset() {
      this.$children.forEach(function (c) {
        return c.reset && c.reset();
      });
    }
  }
});

/***/ }),

/***/ "RfVA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/2/1.
 */
function config(options) {
  options && merge(config, options);
}

merge(config, {
  mouseWheel: false
});

function merge(target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i];
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ "UHna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_loading__ = __webpack_require__("qEhS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bubble_vue__ = __webpack_require__("0wY3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__common_loading__["a" /* default */], Bubble: __WEBPACK_IMPORTED_MODULE_1__bubble_vue__["a" /* default */] },
  props: {
    refreshTxt: String,
    bubbleY: Number,
    md: Boolean,
    top: {},
    beforePullDown: Boolean,
    isPullingDown: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {
    iconStyle: function iconStyle() {
      return {
        transform: 'rotate(' + this.top * 6 + 'deg)'
      };
    }
  },
  methods: {}
});

/***/ }),

/***/ "VJiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PullDown_vue__ = __webpack_require__("UHna");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae55c73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PullDown_vue__ = __webpack_require__("xZ3o");
function injectStyle (ssrContext) {
  __webpack_require__("YD+d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae55c73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PullDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae55c73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PullDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VP5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexSelect_vue__ = __webpack_require__("8thI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57711955_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexSelect_vue__ = __webpack_require__("acfI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57711955_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VSC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_SlideAction_vue__ = __webpack_require__("KnPC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_SlideActionGroup_vue__ = __webpack_require__("tsiT");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_SlideActionGroup_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_SlideAction_vue__["a"]; });
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/02/07.
 */


var VueTouch = __webpack_require__("I0MY");

__WEBPACK_IMPORTED_MODULE_0__src_SlideAction_vue__["a" /* default */].install = function (Vue) {
  Vue.use(VueTouch);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__src_SlideActionGroup_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__src_SlideActionGroup_vue__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_SlideAction_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_SlideAction_vue__["a" /* default */]);
};

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__src_SlideAction_vue__["a" /* default */]);


/***/ }),

/***/ "VUwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(global)) == 'object' && global !== null && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "YD+d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aUn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    y: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      width: 50,
      height: 80
    };
  },

  computed: {
    distance: function distance() {
      return Math.max(0, Math.min(this.y * this.ratio, this.maxDistance));
    },
    style: function style() {
      return 'width:' + this.width / this.ratio + 'px;height:' + this.height / this.ratio + 'px';
    }
  },
  created: function created() {
    this.ratio = window.devicePixelRatio;
    this.width *= this.ratio;
    this.height *= this.ratio;
    this.initRadius = 18 * this.ratio;
    this.minHeadRadius = 12 * this.ratio;
    this.minTailRadius = 5 * this.ratio;
    this.initArrowRadius = 10 * this.ratio;
    this.minArrowRadius = 6 * this.ratio;
    this.arrowWidth = 3 * this.ratio;
    this.maxDistance = 40 * this.ratio;
    this.initCenterX = 25 * this.ratio;
    this.initCenterY = 25 * this.ratio;
    this.headCenter = {
      x: this.initCenterX,
      y: this.initCenterY
    };
  },
  mounted: function mounted() {
    this._draw();
  },

  methods: {
    _draw: function _draw() {
      var bubble = this.$refs.bubble;
      var ctx = bubble.getContext('2d');
      ctx.clearRect(0, 0, bubble.width, bubble.height);

      this._drawBubble(ctx);

      this._drawArrow(ctx);
    },
    _drawBubble: function _drawBubble(ctx) {
      ctx.save();
      ctx.beginPath();

      var rate = this.distance / this.maxDistance;
      var headRadius = this.initRadius - (this.initRadius - this.minHeadRadius) * rate;

      this.headCenter.y = this.initCenterY - (this.initRadius - this.minHeadRadius) * rate;

      // 画上半弧线
      ctx.arc(this.headCenter.x, this.headCenter.y, headRadius, 0, Math.PI, true);

      // 画左侧贝塞尔
      var tailRadius = this.initRadius - (this.initRadius - this.minTailRadius) * rate;
      var tailCenter = {
        x: this.headCenter.x,
        y: this.headCenter.y + this.distance
      };

      var tailPointL = {
        x: tailCenter.x - tailRadius,
        y: tailCenter.y
      };
      var controlPointL = {
        x: tailPointL.x,
        y: tailPointL.y - this.distance / 2
      };

      ctx.quadraticCurveTo(controlPointL.x, controlPointL.y, tailPointL.x, tailPointL.y);

      // 画下半弧线
      ctx.arc(tailCenter.x, tailCenter.y, tailRadius, Math.PI, 0, true);

      // 画右侧贝塞尔
      var headPointR = {
        x: this.headCenter.x + headRadius,
        y: this.headCenter.y
      };
      var controlPointR = {
        x: tailCenter.x + tailRadius,
        y: headPointR.y + this.distance / 2
      };
      ctx.quadraticCurveTo(controlPointR.x, controlPointR.y, headPointR.x, headPointR.y);

      ctx.fillStyle = 'rgb(170,170,170)';
      ctx.fill();
      ctx.strokeStyle = 'rgb(153,153,153)';
      ctx.stroke();
      ctx.restore();
    },
    _drawArrow: function _drawArrow(ctx) {
      ctx.save();
      ctx.beginPath();

      var rate = this.distance / this.maxDistance;
      var arrowRadius = this.initArrowRadius - (this.initArrowRadius - this.minArrowRadius) * rate;

      // 画内圆
      ctx.arc(this.headCenter.x, this.headCenter.y, arrowRadius - (this.arrowWidth - rate), -Math.PI / 2, 0, true);

      // 画外圆
      ctx.arc(this.headCenter.x, this.headCenter.y, arrowRadius, 0, Math.PI * 3 / 2, false);

      ctx.lineTo(this.headCenter.x, this.headCenter.y - arrowRadius - this.arrowWidth / 2 + rate);
      ctx.lineTo(this.headCenter.x + this.arrowWidth * 2 - rate * 2, this.headCenter.y - arrowRadius + this.arrowWidth / 2);

      ctx.lineTo(this.headCenter.x, this.headCenter.y - arrowRadius + this.arrowWidth * 3 / 2 - rate);

      ctx.fillStyle = 'rgb(255,255,255)';
      ctx.fill();
      ctx.strokeStyle = 'rgb(170,170,170)';
      ctx.stroke();
      ctx.restore();
    }
  },
  watch: {
    y: function y() {
      this._draw();
    }
  }
});

/***/ }),

/***/ "acfI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-index-select"},[_c('div',{staticClass:"air-index-select__top"},[_c('div',{staticClass:"air-index-select__search"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.keyword),expression:"keyword",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":_vm.searchHit},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),(_vm.tabs)?_c('div',{staticClass:"air-index-select__tab"},_vm._l((_vm.tabs),function(tab,index){return _c('span',{style:({borderColor: index === _vm.tabIndex ? _vm.activeColor : 'transparent', color: index === _vm.tabIndex ? '#333333' : '#AAAAAA'}),on:{"click":function($event){_vm.tabIndex=index}}},[_vm._v(_vm._s(tab))])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"air-index-select__content",on:{"scroll":_vm.scroll}},[_c('div',{staticClass:"air-index-select__list"},[_c('dl',{directives:[{name:"show",rawName:"v-show",value:(!_vm.keyword),expression:"!keyword"}],class:['air-index-select__dl', 'air-index-select__key-hot']},[_c('dt',[_vm._v("热门")]),_vm._v(" "),_c('dd',_vm._l((_vm.hotData),function(item){return _c('span',{key:item[_vm.keyField],on:{"click":function($event){_vm.clickItem(item)}}},[_vm._v(_vm._s(item[_vm.textField]))])}))]),_vm._v(" "),_vm._l((_vm.listData),function(value,key){return _c('dl',{key:key,class:['air-index-select__dl', 'air-index-select__key-'+key]},[_c('dt',[_vm._v(_vm._s(key))]),_vm._v(" "),_vm._l((value),function(item){return _c('dd',{key:item[_vm.keyField],on:{"click":function($event){_vm.clickItem(item)}}},[_c('span',{staticClass:"air-index-select__text"},[_vm._v(_vm._s(item[_vm.textField]))]),_vm._v(" "),_c('span',{staticClass:"air-index-select__sub-text"},[_vm._v(_vm._s(item[_vm.subTextField]))])])})],2)})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active !== '热'),expression:"active !== '热'"}],staticClass:"air-index-select__title"},[_vm._v(_vm._s(_vm.active))])]),_vm._v(" "),_c('div',{class:['air-index-select__index', {'air-index-select__index--tabs': !!_vm.tabs}],on:{"touchstart":function($event){$event.stopPropagation();$event.preventDefault();_vm.touchstart($event)},"touchmove":function($event){$event.stopPropagation();$event.preventDefault();_vm.touchmove($event)},"touchend":function($event){$event.stopPropagation();$event.preventDefault();_vm.touchend($event)}}},[_vm._l((_vm.index),function(char){return [(char === _vm.active)?_c('span',{staticClass:"air-index-select__char air-index-select__char--active",style:({color:_vm.activeColor}),on:{"click":function($event){_vm.clickChar(char)}}},[_vm._v(_vm._s(char))]):_c('span',{staticClass:"air-index-select__char",on:{"click":function($event){_vm.clickChar(char)}}},[_vm._v(_vm._s(char))])]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTip),expression:"showTip"}],staticClass:"air-index-select__tip"},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bU+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_Scroll_vue__ = __webpack_require__("cmR8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_config__ = __webpack_require__("RfVA");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/11/15.
 */



__WEBPACK_IMPORTED_MODULE_0__src_Scroll_vue__["a" /* default */].install = function (Vue, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__utils_config__["a" /* default */])(options);
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_Scroll_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_Scroll_vue__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_Scroll_vue__["a" /* default */]);

/***/ }),

/***/ "beFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isExpand: false
    };
  },

  methods: {
    toggle: function toggle() {
      this.isExpand = !this.isExpand;
    }
  }
});

/***/ }),

/***/ "cLVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_AirCalendarH__ = __webpack_require__("I1MJ");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/01/22.
 */


__WEBPACK_IMPORTED_MODULE_0__src_AirCalendarH__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_AirCalendarH__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_AirCalendarH__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_AirCalendarH__["a" /* default */]);

/***/ }),

/***/ "cmR8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scroll_vue__ = __webpack_require__("CkX9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a0059d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scroll_vue__ = __webpack_require__("z2fs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scroll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a0059d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scroll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "erXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-nav"},_vm._l(((Object.keys(_vm.data))),function(title){return _c('div',{staticClass:"group-container"},[_c('p',{staticClass:"side-nav-title"},[_vm._v(_vm._s(title))]),_vm._v(" "),_vm._l((_vm.data[title]),function(nav){return (nav.desc)?_c('div',{staticClass:"side-nav-items"},[(nav.name)?_c('router-link',{class:_vm.$route.name===nav.name ? 'active' : '',attrs:{"to":{name: nav.name}}},[_vm._v(_vm._s(nav.desc))]):_c('p',{staticClass:"side-nav-group"},[_vm._v(_vm._s(nav.desc))]),_vm._v(" "),_vm._l((nav.items),function(item){return _c('div',[_c('router-link',{staticClass:"slid-nav-component",class:_vm.$route.name===item.name ? 'active' : '',attrs:{"to":{name: item.name}}},[_vm._v(_vm._s(item.desc))])],1)})],2):_vm._e()})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fMDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-line-map"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ffz/":
/***/ (function(module, exports) {

module.exports = {"开发指南":[{"name":"giud","path":"/giud","desc":"介绍"},{"name":"install","path":"/install","desc":"安装"},{"name":"start","path":"/start","desc":"快速开始"},{"name":"index","path":"/","type":"pages"},{"name":"res","path":"/res","desc":"资源"},{"name":"logs","path":"/logs","desc":"更新日志"}],"组件":[{"desc":"基础组件","path":"/component","items":[{"desc":"滚动组件","name":"scroll","path":"/scroll"}]},{"desc":"视图组件","path":"/component","items":[{"desc":"索引选择器","name":"indexSelect","path":"/indexSelect"},{"desc":"航线地图","name":"airLineMap","path":"/airLineMap"},{"desc":"手风琴","name":"accordion","path":"/accordion"},{"desc":"横向日历","name":"calendarH","path":"/calendarH"},{"desc":"纵向日历","name":"calendarV","path":"/calendarV"},{"desc":"数据加载","name":"dataBlock","path":"/dataBlock"},{"desc":"滑动操作","name":"slideAction","path":"/slideAction"}]}]}

/***/ }),

/***/ "gGbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_config__ = __webpack_require__("RfVA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AirIndexSelect__ = __webpack_require__("ky4F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AirIndexList__ = __webpack_require__("rzs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AirLineMap__ = __webpack_require__("F/Gm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AirAccordion__ = __webpack_require__("6jSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AirCalendarH__ = __webpack_require__("cLVC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AirCalendarV__ = __webpack_require__("Lneg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AirScroll__ = __webpack_require__("bU+v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AirDataBlock__ = __webpack_require__("lFDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AirSlideAction__ = __webpack_require__("VSC+");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/12/15.
 */

var VueTouch = __webpack_require__("I0MY");










var components = [__WEBPACK_IMPORTED_MODULE_1__components_AirIndexSelect__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_AirIndexList__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_AirLineMap__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__components_AirAccordion__["a" /* AirAccordion */], __WEBPACK_IMPORTED_MODULE_4__components_AirAccordion__["b" /* AirAccordionContent */], __WEBPACK_IMPORTED_MODULE_5__components_AirCalendarH__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_AirCalendarV__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_AirScroll__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_AirDataBlock__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__components_AirSlideAction__["a" /* AirSlideAction */], __WEBPACK_IMPORTED_MODULE_9__components_AirSlideAction__["b" /* AirSlideActionGroup */]];

var install = function install(Vue, options) {
  if (install.installed) return;
  Vue.use(VueTouch);
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_config__["a" /* default */])(options);
  components.map(function (component) {
    return Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),

/***/ "hXuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs-demo-wrapper"},[_c('div',{staticClass:"demo-container",style:({height: _vm.isExpand ? 'auto' : '0'})},[_c('div',{attrs:{"span":"14"}},[_c('div',{staticClass:"docs-demo docs-demo--expand"},[_c('div',{staticClass:"highlight-wrapper"},[_vm._t("highlight")],2)])])]),_vm._v(" "),_c('span',{staticClass:"docs-trans docs-demo__triangle",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.isExpand ? '隐藏代码' : '显示代码'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iM+w":
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","features":[{"type":"Feature","properties":{"id":"65","name":"新疆","cp":[84.9023,41.748],"childNum":18},"geometry":{"type":"Polygon","coordinates":[[[96.416,42.7588],[96.416,42.7148],[95.9766,42.4951],[96.0645,42.3193],[96.2402,42.2314],[95.9766,41.9238],[95.2734,41.6162],[95.1855,41.792],[94.5703,41.4844],[94.043,41.0889],[93.8672,40.6934],[93.0762,40.6494],[92.6367,39.6387],[92.373,39.3311],[92.373,39.1113],[92.373,39.0234],[90.1758,38.4961],[90.3516,38.2324],[90.6152,38.3203],[90.5273,37.8369],[91.0547,37.4414],[91.3184,37.0898],[90.7031,36.7822],[90.791,36.6064],[91.0547,36.5186],[91.0547,36.0791],[90.8789,36.0352],[90,36.2549],[89.9121,36.0791],[89.7363,36.0791],[89.209,36.2988],[88.7695,36.3428],[88.5938,36.4746],[87.3633,36.4307],[86.2207,36.167],[86.1328,35.8594],[85.6055,35.6836],[85.0781,35.7275],[84.1992,35.376],[83.1445,35.4199],[82.8809,35.6836],[82.4414,35.7275],[82.002,35.332],[81.6504,35.2441],[80.4199,35.4199],[80.2441,35.2881],[80.332,35.1563],[80.2441,35.2002],[79.8926,34.8047],[79.8047,34.4971],[79.1016,34.4531],[79.0137,34.3213],[78.2227,34.7168],[78.0469,35.2441],[78.0469,35.5078],[77.4316,35.4639],[76.8164,35.6396],[76.5527,35.8594],[76.2012,35.8154],[75.9375,36.0352],[76.0254,36.4746],[75.8496,36.6943],[75.498,36.7383],[75.4102,36.958],[75.0586,37.002],[74.8828,36.9141],[74.7949,37.0459],[74.5313,37.0898],[74.5313,37.2217],[74.8828,37.2217],[75.1465,37.4414],[74.8828,37.5732],[74.9707,37.749],[74.8828,38.4521],[74.3555,38.6719],[74.1797,38.6719],[74.0918,38.54],[73.8281,38.584],[73.7402,38.8477],[73.8281,38.9795],[73.4766,39.375],[73.916,39.5068],[73.916,39.6826],[73.8281,39.7705],[74.0039,40.0342],[74.8828,40.3418],[74.7949,40.5176],[75.2344,40.4297],[75.5859,40.6494],[75.7617,40.2979],[76.377,40.3857],[76.9043,41.001],[77.6074,41.001],[78.1348,41.2207],[78.1348,41.3965],[80.1563,42.0557],[80.2441,42.2754],[80.1563,42.627],[80.2441,42.8467],[80.5078,42.8906],[80.4199,43.0664],[80.7715,43.1982],[80.4199,44.165],[80.4199,44.6045],[79.9805,44.8242],[79.9805,44.9561],[81.7383,45.3955],[82.0898,45.2197],[82.5293,45.2197],[82.2656,45.6592],[83.0566,47.2412],[83.6719,47.0215],[84.7266,47.0215],[84.9023,46.8896],[85.5176,47.0654],[85.6934,47.2852],[85.5176,48.1201],[85.7813,48.4277],[86.5723,48.5596],[86.8359,48.8232],[86.748,48.9551],[86.8359,49.1309],[87.8027,49.1748],[87.8906,48.999],[87.7148,48.9111],[88.0664,48.7354],[87.9785,48.6035],[88.5059,48.3838],[88.6816,48.1641],[89.1211,47.9883],[89.5605,48.0322],[89.7363,47.8564],[90.0879,47.8564],[90.3516,47.6807],[90.5273,47.2412],[90.8789,46.9775],[91.0547,46.582],[90.8789,46.3184],[91.0547,46.0107],[90.7031,45.7471],[90.7031,45.5273],[90.8789,45.2197],[91.582,45.0879],[93.5156,44.9561],[94.7461,44.3408],[95.3613,44.2969],[95.3613,44.0332],[95.5371,43.9014],[95.8887,43.2422],[96.3281,42.9346],[96.416,42.7588]]]}},{"type":"Feature","properties":{"id":"54","name":"西藏","cp":[88.7695,31.6846],"childNum":7},"geometry":{"type":"Polygon","coordinates":[[[79.0137,34.3213],[79.1016,34.4531],[79.8047,34.4971],[79.8926,34.8047],[80.2441,35.2002],[80.332,35.1563],[80.2441,35.2881],[80.4199,35.4199],[81.6504,35.2441],[82.002,35.332],[82.4414,35.7275],[82.8809,35.6836],[83.1445,35.4199],[84.1992,35.376],[85.0781,35.7275],[85.6055,35.6836],[86.1328,35.8594],[86.2207,36.167],[87.3633,36.4307],[88.5938,36.4746],[88.7695,36.3428],[89.209,36.2988],[89.7363,36.0791],[89.3848,36.0352],[89.4727,35.9033],[89.7363,35.7715],[89.7363,35.4199],[89.4727,35.376],[89.4727,35.2441],[89.5605,34.8926],[89.8242,34.8486],[89.7363,34.6729],[89.8242,34.3652],[89.6484,34.0137],[90.0879,33.4863],[90.7031,33.1348],[91.4063,33.1348],[91.9336,32.8271],[92.1973,32.8271],[92.2852,32.7393],[92.9883,32.7393],[93.5156,32.4756],[93.7793,32.5635],[94.1309,32.4316],[94.6582,32.6074],[95.1855,32.4316],[95.0098,32.2998],[95.1855,32.3438],[95.2734,32.2119],[95.3613,32.168],[95.3613,31.9922],[95.4492,31.8164],[95.8008,31.6846],[95.9766,31.8164],[96.1523,31.5967],[96.2402,31.9482],[96.5039,31.7285],[96.8555,31.6846],[96.7676,31.9922],[97.2949,32.0801],[97.3828,32.5635],[97.7344,32.5195],[98.1738,32.3438],[98.4375,31.8604],[98.877,31.4209],[98.6133,31.2012],[98.9648,30.7617],[99.1406,29.2676],[98.9648,29.1357],[98.9648,28.8281],[98.7891,28.8721],[98.7891,29.0039],[98.7012,28.916],[98.6133,28.5205],[98.7891,28.3447],[98.7012,28.2129],[98.3496,28.125],[98.2617,28.3887],[98.1738,28.125],[97.5586,28.5205],[97.2949,28.0811],[97.3828,27.9053],[97.0313,27.7295],[96.5039,28.125],[95.7129,28.2568],[95.3613,28.125],[95.2734,27.9492],[94.2188,27.5537],[93.8672,27.0264],[93.6035,26.9385],[92.1094,26.8506],[92.0215,27.4658],[91.582,27.5537],[91.582,27.9053],[91.4063,28.0371],[91.0547,27.8613],[90.7031,28.0811],[89.8242,28.2129],[89.6484,28.1689],[89.1211,27.5977],[89.1211,27.334],[89.0332,27.2021],[88.7695,27.4219],[88.8574,27.9932],[88.6816,28.125],[88.1543,27.9053],[87.8906,27.9492],[87.7148,27.8174],[87.0996,27.8174],[86.748,28.125],[86.5723,28.125],[86.4844,27.9053],[86.1328,28.125],[86.0449,27.9053],[85.6934,28.3447],[85.6055,28.2568],[85.166,28.3447],[85.166,28.6523],[84.9023,28.5645],[84.4629,28.7402],[84.2871,28.8721],[84.1992,29.2236],[84.1113,29.2676],[83.584,29.1797],[83.2324,29.5752],[82.1777,30.0586],[82.0898,30.3223],[81.3867,30.3662],[81.2109,30.0146],[81.0352,30.2344],[80.0684,30.5859],[79.7168,30.9375],[79.0137,31.0693],[78.75,31.333],[78.8379,31.5967],[78.6621,31.8164],[78.75,31.9043],[78.4863,32.124],[78.3984,32.5195],[78.75,32.6953],[78.9258,32.3438],[79.2773,32.5635],[79.1016,33.1787],[78.6621,33.6621],[78.6621,34.1016],[78.9258,34.1455],[79.0137,34.3213]]]}},{"type":"Feature","properties":{"id":"15","name":"内蒙古","cp":[117.5977,44.3408],"childNum":12},"geometry":{"type":"Polygon","coordinates":[[[97.207,42.8027],[99.4922,42.583],[100.8105,42.6709],[101.7773,42.4951],[102.041,42.2314],[102.7441,42.1436],[103.3594,41.8799],[103.8867,41.792],[104.502,41.8799],[104.502,41.6602],[105.0293,41.5723],[105.7324,41.9238],[107.4023,42.4512],[109.4238,42.4512],[110.3906,42.7588],[111.0059,43.3301],[111.9727,43.6816],[111.9727,43.8135],[111.4453,44.3848],[111.7969,45],[111.9727,45.0879],[113.6426,44.7363],[114.1699,44.9561],[114.5215,45.3955],[115.6641,45.4395],[116.1914,45.7031],[116.2793,45.9668],[116.543,46.2744],[117.334,46.3623],[117.4219,46.582],[117.7734,46.5381],[118.3008,46.7578],[118.7402,46.7139],[118.916,46.7578],[119.0918,46.6699],[119.707,46.626],[119.9707,46.7139],[119.707,47.1973],[118.4766,47.9883],[117.8613,48.0322],[117.334,47.6807],[116.8066,47.9004],[116.1914,47.8564],[115.9277,47.6807],[115.5762,47.9004],[115.4883,48.1641],[115.8398,48.252],[115.8398,48.5596],[116.7188,49.834],[117.7734,49.5264],[118.5645,49.9219],[119.2676,50.0977],[119.3555,50.3174],[119.1797,50.3613],[119.5313,50.7568],[119.5313,50.8887],[119.707,51.0645],[120.1465,51.6797],[120.6738,51.9434],[120.7617,52.1191],[120.7617,52.251],[120.5859,52.3389],[120.6738,52.5146],[120.4102,52.6465],[120.0586,52.6025],[120.0586,52.7344],[120.8496,53.2617],[121.4648,53.3496],[121.8164,53.042],[121.2012,52.5586],[121.6406,52.4268],[121.7285,52.2949],[121.9922,52.2949],[122.168,52.5146],[122.6953,52.251],[122.6074,52.0752],[122.959,51.3281],[123.3105,51.2402],[123.6621,51.3721],[124.3652,51.2842],[124.541,51.3721],[124.8926,51.3721],[125.0684,51.6357],[125.332,51.6357],[126.0352,51.0205],[125.7715,50.7568],[125.7715,50.5371],[125.332,50.1416],[125.1563,49.834],[125.2441,49.1748],[124.8047,49.1309],[124.4531,48.1201],[124.2773,48.5156],[122.4316,47.373],[123.0469,46.7139],[123.3984,46.8896],[123.3984,46.9775],[123.4863,46.9775],[123.5742,46.8457],[123.5742,46.8896],[123.5742,46.6699],[123.0469,46.582],[123.2227,46.2305],[122.7832,46.0107],[122.6953,45.7031],[122.4316,45.8789],[122.2559,45.791],[121.8164,46.0107],[121.7285,45.7471],[121.9043,45.7031],[122.2559,45.2637],[122.0801,44.8682],[122.3438,44.2529],[123.1348,44.4727],[123.4863,43.7256],[123.3105,43.5059],[123.6621,43.374],[123.5742,43.0225],[123.3105,42.9785],[123.1348,42.8027],[122.7832,42.7148],[122.3438,42.8467],[122.3438,42.6709],[121.9922,42.7148],[121.7285,42.4512],[121.4648,42.4951],[120.498,42.0996],[120.1465,41.7041],[119.8828,42.1875],[119.5313,42.3633],[119.3555,42.2754],[119.2676,41.7041],[119.4434,41.6162],[119.2676,41.3086],[118.3887,41.3086],[118.125,41.748],[118.3008,41.792],[118.3008,42.0996],[118.125,42.0557],[117.9492,42.2314],[118.0371,42.4072],[117.7734,42.627],[117.5098,42.583],[117.334,42.4512],[116.8945,42.4072],[116.8066,42.0117],[116.2793,42.0117],[116.0156,41.792],[115.9277,41.9238],[115.2246,41.5723],[114.9609,41.6162],[114.873,42.0996],[114.5215,42.1436],[114.1699,41.792],[114.2578,41.5723],[113.9063,41.4404],[113.9941,41.2207],[113.9063,41.1328],[114.082,40.7373],[114.082,40.5176],[113.8184,40.5176],[113.5547,40.3418],[113.2031,40.3857],[112.7637,40.166],[112.3242,40.2539],[111.9727,39.5947],[111.4453,39.6387],[111.3574,39.4189],[111.0938,39.375],[111.0938,39.5947],[110.6543,39.2871],[110.127,39.4629],[110.2148,39.2871],[109.8633,39.2432],[109.9512,39.1553],[108.9844,38.3203],[109.0723,38.0127],[108.8965,37.9688],[108.8086,38.0127],[108.7207,37.7051],[108.1934,37.6172],[107.666,37.8809],[107.3145,38.1006],[106.7871,38.1885],[106.5234,38.3203],[106.9629,38.9795],[106.7871,39.375],[106.3477,39.2871],[105.9082,38.7158],[105.8203,37.793],[104.3262,37.4414],[103.4473,37.8369],[103.3594,38.0127],[103.5352,38.1445],[103.4473,38.3643],[104.2383,38.9795],[104.0625,39.4189],[103.3594,39.3311],[103.0078,39.1113],[102.4805,39.2432],[101.8652,39.1113],[102.041,38.8916],[101.7773,38.6719],[101.3379,38.7598],[101.25,39.0234],[100.9863,38.9355],[100.8105,39.4189],[100.5469,39.4189],[100.0195,39.7705],[99.4922,39.8584],[100.1074,40.2539],[100.1953,40.6494],[99.9316,41.001],[99.2285,40.8691],[99.0527,40.6934],[98.9648,40.7813],[98.7891,40.6055],[98.5254,40.7373],[98.6133,40.6494],[98.3496,40.5615],[98.3496,40.9131],[97.4707,41.4844],[97.8223,41.6162],[97.8223,41.748],[97.207,42.8027]]]}},{"type":"Feature","properties":{"id":"63","name":"青海","cp":[96.2402,35.4199],"childNum":8},"geometry":{"type":"Polygon","coordinates":[[[89.7363,36.0791],[89.9121,36.0791],[90,36.2549],[90.8789,36.0352],[91.0547,36.0791],[91.0547,36.5186],[90.791,36.6064],[90.7031,36.7822],[91.3184,37.0898],[91.0547,37.4414],[90.5273,37.8369],[90.6152,38.3203],[90.3516,38.2324],[90.1758,38.4961],[92.373,39.0234],[92.373,39.1113],[93.1641,39.1992],[93.1641,38.9795],[93.6914,38.9355],[93.8672,38.7158],[94.3066,38.7598],[94.5703,38.3643],[95.0098,38.4082],[95.4492,38.2764],[95.7129,38.3643],[96.2402,38.1006],[96.416,38.2324],[96.6797,38.1885],[96.6797,38.4521],[97.1191,38.584],[97.0313,39.1992],[98.1738,38.8037],[98.3496,39.0234],[98.6133,38.9355],[98.7891,39.0674],[99.1406,38.9355],[99.8438,38.3643],[100.1953,38.2764],[100.0195,38.4521],[100.1074,38.4961],[100.459,38.2764],[100.7227,38.2324],[101.1621,37.8369],[101.5137,37.8809],[101.7773,37.6172],[101.9531,37.7051],[102.1289,37.4414],[102.5684,37.1777],[102.4805,36.958],[102.6563,36.8262],[102.5684,36.7383],[102.832,36.3428],[103.0078,36.2549],[102.9199,36.0791],[102.9199,35.9033],[102.6563,35.7715],[102.832,35.5957],[102.4805,35.5957],[102.3047,35.4199],[102.3926,35.2002],[101.9531,34.8486],[101.9531,34.6289],[102.2168,34.4092],[102.1289,34.2773],[101.6895,34.1016],[100.9863,34.3652],[100.8105,34.2773],[101.25,33.6621],[101.5137,33.7061],[101.6016,33.5303],[101.7773,33.5303],[101.6895,33.3105],[101.7773,33.2227],[101.6016,33.1348],[101.1621,33.2227],[101.25,32.6953],[100.7227,32.6514],[100.7227,32.5195],[100.3711,32.7393],[100.1074,32.6514],[100.1074,32.8711],[99.8438,33.0029],[99.7559,32.7393],[99.2285,32.915],[99.2285,33.0469],[98.877,33.1787],[98.4375,34.0576],[97.8223,34.1895],[97.6465,34.1016],[97.7344,33.9258],[97.3828,33.8818],[97.4707,33.5742],[97.7344,33.3984],[97.3828,32.8711],[97.4707,32.6953],[97.7344,32.5195],[97.3828,32.5635],[97.2949,32.0801],[96.7676,31.9922],[96.8555,31.6846],[96.5039,31.7285],[96.2402,31.9482],[96.1523,31.5967],[95.9766,31.8164],[95.8008,31.6846],[95.4492,31.8164],[95.3613,31.9922],[95.3613,32.168],[95.2734,32.2119],[95.1855,32.3438],[95.0098,32.2998],[95.1855,32.4316],[94.6582,32.6074],[94.1309,32.4316],[93.7793,32.5635],[93.5156,32.4756],[92.9883,32.7393],[92.2852,32.7393],[92.1973,32.8271],[91.9336,32.8271],[91.4063,33.1348],[90.7031,33.1348],[90.0879,33.4863],[89.6484,34.0137],[89.8242,34.3652],[89.7363,34.6729],[89.8242,34.8486],[89.5605,34.8926],[89.4727,35.2441],[89.4727,35.376],[89.7363,35.4199],[89.7363,35.7715],[89.4727,35.9033],[89.3848,36.0352],[89.7363,36.0791]]]}},{"type":"Feature","properties":{"id":"51","name":"四川","cp":[102.9199,30.1904],"childNum":21},"geometry":{"type":"Polygon","coordinates":[[[101.7773,33.5303],[101.8652,33.5742],[101.9531,33.4424],[101.8652,33.0908],[102.4805,33.4424],[102.2168,33.9258],[102.9199,34.3213],[103.0957,34.1895],[103.1836,33.7939],[104.1504,33.6182],[104.2383,33.3984],[104.4141,33.3105],[104.3262,33.2227],[104.4141,33.0469],[104.3262,32.8711],[104.4141,32.7393],[105.2051,32.6074],[105.3809,32.7393],[105.3809,32.8711],[105.4688,32.915],[105.5566,32.7393],[106.084,32.8711],[106.084,32.7393],[106.3477,32.6514],[107.0508,32.6953],[107.1387,32.4756],[107.2266,32.4316],[107.4023,32.5195],[108.0176,32.168],[108.2813,32.2559],[108.5449,32.2119],[108.3691,32.168],[108.2813,31.9043],[108.5449,31.6846],[108.1934,31.5088],[107.9297,30.8496],[107.4902,30.8496],[107.4023,30.7617],[107.4902,30.6299],[107.0508,30.0146],[106.7871,30.0146],[106.6113,30.3223],[106.2598,30.1904],[105.8203,30.4541],[105.6445,30.2783],[105.5566,30.1025],[105.7324,29.8828],[105.293,29.5313],[105.4688,29.3115],[105.7324,29.2676],[105.8203,28.96],[106.2598,28.8721],[106.3477,28.5205],[105.9961,28.7402],[105.6445,28.4326],[105.9082,28.125],[106.1719,28.125],[106.3477,27.8174],[105.6445,27.6416],[105.5566,27.7734],[105.293,27.7295],[105.2051,27.9932],[105.0293,28.0811],[104.8535,27.9053],[104.4141,27.9492],[104.3262,28.0371],[104.4141,28.125],[104.4141,28.2568],[104.2383,28.4326],[104.4141,28.6084],[103.8867,28.6523],[103.7988,28.3008],[103.4473,28.125],[103.4473,27.7734],[102.9199,27.29],[103.0078,26.3672],[102.6563,26.1914],[102.5684,26.3672],[102.1289,26.1035],[101.8652,26.0596],[101.6016,26.2354],[101.6895,26.3672],[101.4258,26.5869],[101.4258,26.8066],[101.4258,26.7188],[101.1621,27.0264],[101.1621,27.1582],[100.7227,27.8613],[100.3711,27.8174],[100.2832,27.7295],[100.0195,28.125],[100.1953,28.3447],[99.668,28.8281],[99.4043,28.5205],[99.4043,28.1689],[99.2285,28.3008],[99.1406,29.2676],[98.9648,30.7617],[98.6133,31.2012],[98.877,31.4209],[98.4375,31.8604],[98.1738,32.3438],[97.7344,32.5195],[97.4707,32.6953],[97.3828,32.8711],[97.7344,33.3984],[97.4707,33.5742],[97.3828,33.8818],[97.7344,33.9258],[97.6465,34.1016],[97.8223,34.1895],[98.4375,34.0576],[98.877,33.1787],[99.2285,33.0469],[99.2285,32.915],[99.7559,32.7393],[99.8438,33.0029],[100.1074,32.8711],[100.1074,32.6514],[100.3711,32.7393],[100.7227,32.5195],[100.7227,32.6514],[101.25,32.6953],[101.1621,33.2227],[101.6016,33.1348],[101.7773,33.2227],[101.6895,33.3105],[101.7773,33.5303]]]}},{"type":"Feature","properties":{"id":"23","name":"黑龙江","cp":[128.1445,48.5156],"childNum":13},"geometry":{"type":"Polygon","coordinates":[[[121.4648,53.3496],[123.6621,53.5693],[124.8926,53.0859],[125.0684,53.2178],[125.5957,53.0859],[125.6836,52.9102],[126.123,52.7783],[126.0352,52.6025],[126.2109,52.5146],[126.3867,52.2949],[126.3867,52.207],[126.5625,52.1631],[126.4746,51.9434],[126.9141,51.3721],[126.8262,51.2842],[127.002,51.3281],[126.9141,51.1084],[127.2656,50.7568],[127.3535,50.2734],[127.6172,50.2295],[127.5293,49.8779],[127.793,49.6143],[128.7598,49.5703],[129.1113,49.3506],[129.4629,49.4385],[130.2539,48.8672],[130.6934,48.8672],[130.5176,48.6475],[130.8691,48.2959],[130.6934,48.1201],[131.0449,47.6807],[132.5391,47.7246],[132.627,47.9443],[133.0664,48.1201],[133.5059,48.1201],[134.209,48.3838],[135.0879,48.4277],[134.7363,48.252],[134.5605,47.9883],[134.7363,47.6807],[134.5605,47.4609],[134.3848,47.4609],[134.209,47.2852],[134.209,47.1533],[133.8574,46.5381],[133.9453,46.2744],[133.5059,45.835],[133.418,45.5713],[133.2422,45.5273],[133.0664,45.1318],[132.8906,45.0439],[131.9238,45.3516],[131.5723,45.0439],[131.0449,44.8682],[131.3086,44.0771],[131.2207,43.7256],[131.3086,43.4619],[130.8691,43.418],[130.5176,43.6377],[130.3418,43.9893],[129.9902,43.8574],[129.9023,44.0332],[129.8145,43.9014],[129.2871,43.8135],[129.1992,43.5938],[128.8477,43.5498],[128.4961,44.165],[128.4082,44.4727],[128.0566,44.3408],[128.0566,44.1211],[127.7051,44.1211],[127.5293,44.6045],[127.0898,44.6045],[127.002,44.7803],[127.0898,45],[126.9141,45.1318],[126.5625,45.2637],[126.0352,45.1758],[125.7715,45.3076],[125.6836,45.5273],[125.0684,45.3955],[124.8926,45.5273],[124.3652,45.4395],[124.0137,45.7471],[123.9258,46.2305],[123.2227,46.2305],[123.0469,46.582],[123.5742,46.6699],[123.5742,46.8896],[123.5742,46.8457],[123.4863,46.9775],[123.3984,46.9775],[123.3984,46.8896],[123.0469,46.7139],[122.4316,47.373],[124.2773,48.5156],[124.4531,48.1201],[124.8047,49.1309],[125.2441,49.1748],[125.1563,49.834],[125.332,50.1416],[125.7715,50.5371],[125.7715,50.7568],[126.0352,51.0205],[125.332,51.6357],[125.0684,51.6357],[124.8926,51.3721],[124.541,51.3721],[124.3652,51.2842],[123.6621,51.3721],[123.3105,51.2402],[122.959,51.3281],[122.6074,52.0752],[122.6953,52.251],[122.168,52.5146],[121.9922,52.2949],[121.7285,52.2949],[121.6406,52.4268],[121.2012,52.5586],[121.8164,53.042],[121.4648,53.3496]]]}},{"type":"Feature","properties":{"id":"62","name":"甘肃","cp":[95.7129,40.166],"childNum":14},"geometry":{"type":"Polygon","coordinates":[[[96.416,42.7148],[97.207,42.8027],[97.8223,41.748],[97.8223,41.6162],[97.4707,41.4844],[98.3496,40.9131],[98.3496,40.5615],[98.6133,40.6494],[98.5254,40.7373],[98.7891,40.6055],[98.9648,40.7813],[99.0527,40.6934],[99.2285,40.8691],[99.9316,41.001],[100.1953,40.6494],[100.1074,40.2539],[99.4922,39.8584],[100.0195,39.7705],[100.5469,39.4189],[100.8105,39.4189],[100.9863,38.9355],[101.25,39.0234],[101.3379,38.7598],[101.7773,38.6719],[102.041,38.8916],[101.8652,39.1113],[102.4805,39.2432],[103.0078,39.1113],[103.3594,39.3311],[104.0625,39.4189],[104.2383,38.9795],[103.4473,38.3643],[103.5352,38.1445],[103.3594,38.0127],[103.4473,37.8369],[104.3262,37.4414],[104.5898,37.4414],[104.5898,37.2217],[104.8535,37.2217],[105.293,36.8262],[105.2051,36.6943],[105.4688,36.123],[105.293,35.9912],[105.3809,35.7715],[105.7324,35.7275],[105.8203,35.5518],[105.9961,35.4639],[105.9082,35.4199],[105.9961,35.4199],[106.084,35.376],[106.2598,35.4199],[106.3477,35.2441],[106.5234,35.332],[106.4355,35.6836],[106.6992,35.6836],[106.9629,35.8154],[106.875,36.123],[106.5234,36.2549],[106.5234,36.4746],[106.4355,36.5625],[106.6113,36.7822],[106.6113,37.0898],[107.3145,37.0898],[107.3145,36.9141],[108.7207,36.3428],[108.6328,35.9912],[108.5449,35.8594],[108.6328,35.5518],[108.5449,35.2881],[107.7539,35.2881],[107.7539,35.1123],[107.8418,35.0244],[107.666,34.9365],[107.2266,34.8926],[106.9629,35.0684],[106.6113,35.0684],[106.5234,34.7607],[106.3477,34.585],[106.6992,34.3213],[106.5234,34.2773],[106.6113,34.1455],[106.4355,33.9258],[106.5234,33.5303],[105.9961,33.6182],[105.7324,33.3984],[105.9961,33.1787],[105.9082,33.0029],[105.4688,32.915],[105.3809,32.8711],[105.3809,32.7393],[105.2051,32.6074],[104.4141,32.7393],[104.3262,32.8711],[104.4141,33.0469],[104.3262,33.2227],[104.4141,33.3105],[104.2383,33.3984],[104.1504,33.6182],[103.1836,33.7939],[103.0957,34.1895],[102.9199,34.3213],[102.2168,33.9258],[102.4805,33.4424],[101.8652,33.0908],[101.9531,33.4424],[101.8652,33.5742],[101.7773,33.5303],[101.6016,33.5303],[101.5137,33.7061],[101.25,33.6621],[100.8105,34.2773],[100.9863,34.3652],[101.6895,34.1016],[102.1289,34.2773],[102.2168,34.4092],[101.9531,34.6289],[101.9531,34.8486],[102.3926,35.2002],[102.3047,35.4199],[102.4805,35.5957],[102.832,35.5957],[102.6563,35.7715],[102.9199,35.9033],[102.9199,36.0791],[103.0078,36.2549],[102.832,36.3428],[102.5684,36.7383],[102.6563,36.8262],[102.4805,36.958],[102.5684,37.1777],[102.1289,37.4414],[101.9531,37.7051],[101.7773,37.6172],[101.5137,37.8809],[101.1621,37.8369],[100.7227,38.2324],[100.459,38.2764],[100.1074,38.4961],[100.0195,38.4521],[100.1953,38.2764],[99.8438,38.3643],[99.1406,38.9355],[98.7891,39.0674],[98.6133,38.9355],[98.3496,39.0234],[98.1738,38.8037],[97.0313,39.1992],[97.1191,38.584],[96.6797,38.4521],[96.6797,38.1885],[96.416,38.2324],[96.2402,38.1006],[95.7129,38.3643],[95.4492,38.2764],[95.0098,38.4082],[94.5703,38.3643],[94.3066,38.7598],[93.8672,38.7158],[93.6914,38.9355],[93.1641,38.9795],[93.1641,39.1992],[92.373,39.1113],[92.373,39.3311],[92.6367,39.6387],[93.0762,40.6494],[93.8672,40.6934],[94.043,41.0889],[94.5703,41.4844],[95.1855,41.792],[95.2734,41.6162],[95.9766,41.9238],[96.2402,42.2314],[96.0645,42.3193],[95.9766,42.4951],[96.416,42.7148]]]}},{"type":"Feature","properties":{"id":"53","name":"云南","cp":[101.8652,25.1807],"childNum":16},"geometry":{"type":"Polygon","coordinates":[[[98.1738,28.125],[98.2617,28.3887],[98.3496,28.125],[98.7012,28.2129],[98.7891,28.3447],[98.6133,28.5205],[98.7012,28.916],[98.7891,29.0039],[98.7891,28.8721],[98.9648,28.8281],[98.9648,29.1357],[99.1406,29.2676],[99.2285,28.3008],[99.4043,28.1689],[99.4043,28.5205],[99.668,28.8281],[100.1953,28.3447],[100.0195,28.125],[100.2832,27.7295],[100.3711,27.8174],[100.7227,27.8613],[101.1621,27.1582],[101.1621,27.0264],[101.4258,26.7188],[101.4258,26.8066],[101.4258,26.5869],[101.6895,26.3672],[101.6016,26.2354],[101.8652,26.0596],[102.1289,26.1035],[102.5684,26.3672],[102.6563,26.1914],[103.0078,26.3672],[102.9199,27.29],[103.4473,27.7734],[103.4473,28.125],[103.7988,28.3008],[103.8867,28.6523],[104.4141,28.6084],[104.2383,28.4326],[104.4141,28.2568],[104.4141,28.125],[104.3262,28.0371],[104.4141,27.9492],[104.8535,27.9053],[105.0293,28.0811],[105.2051,27.9932],[105.293,27.7295],[105.2051,27.3779],[104.5898,27.334],[104.4141,27.4658],[104.1504,27.2461],[103.8867,27.4219],[103.623,27.0264],[103.7109,26.9824],[103.7109,26.7627],[103.8867,26.543],[104.4141,26.6748],[104.6777,26.4111],[104.3262,25.708],[104.8535,25.2246],[104.5898,25.0488],[104.6777,24.9609],[104.502,24.7412],[104.6777,24.3457],[104.7656,24.4775],[105.0293,24.4336],[105.2051,24.082],[105.4688,24.0381],[105.5566,24.126],[105.9961,24.126],[106.1719,23.8184],[106.1719,23.5547],[105.6445,23.4229],[105.5566,23.2031],[105.293,23.3789],[104.8535,23.1592],[104.7656,22.8516],[104.3262,22.6758],[104.1504,22.8076],[103.9746,22.5439],[103.623,22.7637],[103.5352,22.5879],[103.3594,22.8076],[103.0957,22.4561],[102.4805,22.7637],[102.3047,22.4121],[101.8652,22.3682],[101.7773,22.5],[101.6016,22.1924],[101.8652,21.6211],[101.7773,21.1377],[101.6016,21.2256],[101.25,21.1816],[101.1621,21.7529],[100.6348,21.4453],[100.1074,21.4893],[99.9316,22.0605],[99.2285,22.1484],[99.4043,22.5879],[99.3164,22.7197],[99.4922,23.0713],[98.877,23.2031],[98.7012,23.9502],[98.877,24.126],[98.1738,24.082],[97.7344,23.8623],[97.5586,23.9063],[97.7344,24.126],[97.6465,24.4336],[97.5586,24.4336],[97.5586,24.7412],[97.7344,24.8291],[97.8223,25.2686],[98.1738,25.4004],[98.1738,25.6201],[98.3496,25.5762],[98.5254,25.8398],[98.7012,25.8838],[98.6133,26.0596],[98.7012,26.1475],[98.7891,26.5869],[98.7012,27.5098],[98.5254,27.6416],[98.3496,27.5098],[98.1738,28.125]]]}},{"type":"Feature","properties":{"id":"45","name":"广西","cp":[108.2813,23.6426],"childNum":14},"geometry":{"type":"Polygon","coordinates":[[[104.502,24.7412],[104.6777,24.6094],[105.2051,24.9609],[105.9961,24.6533],[106.1719,24.7852],[106.1719,24.9609],[106.875,25.1807],[107.0508,25.2686],[106.9629,25.4883],[107.2266,25.6201],[107.4902,25.2246],[107.7539,25.2246],[107.8418,25.1367],[108.1055,25.2246],[108.1934,25.4443],[108.3691,25.5322],[108.6328,25.3125],[108.6328,25.5762],[109.0723,25.5322],[108.9844,25.752],[109.3359,25.708],[109.5117,26.0156],[109.7754,25.8838],[109.9512,26.1914],[110.2148,25.9717],[110.5664,26.3232],[111.1816,26.3232],[111.2695,26.2354],[111.2695,25.8838],[111.4453,25.8398],[111.0059,25.0049],[111.0938,24.9609],[111.3574,25.1367],[111.5332,24.6533],[111.709,24.7852],[112.0605,24.7412],[111.8848,24.6533],[112.0605,24.3457],[111.8848,24.2139],[111.8848,23.9941],[111.7969,23.8184],[111.6211,23.8184],[111.6211,23.6865],[111.3574,23.4668],[111.4453,23.0273],[111.2695,22.8076],[110.7422,22.5439],[110.7422,22.2803],[110.6543,22.1484],[110.3027,22.1484],[110.3027,21.8848],[109.9512,21.8408],[109.8633,21.665],[109.7754,21.6211],[109.7754,21.4014],[109.5996,21.4453],[109.1602,21.3574],[109.248,21.123],[109.0723,21.212],[109.0723,21.5332],[108.7207,21.5332],[108.6328,21.665],[108.2813,21.4893],[107.8418,21.6211],[107.4023,21.6211],[107.0508,21.7969],[107.0508,21.9287],[106.6992,22.0166],[106.6113,22.4121],[106.7871,22.7637],[106.6992,22.8955],[105.9082,22.9395],[105.5566,23.0713],[105.5566,23.2031],[105.6445,23.4229],[106.1719,23.5547],[106.1719,23.8184],[105.9961,24.126],[105.5566,24.126],[105.4688,24.0381],[105.2051,24.082],[105.0293,24.4336],[104.7656,24.4775],[104.6777,24.3457],[104.502,24.7412]]]}},{"type":"Feature","properties":{"id":"43","name":"湖南","cp":[111.5332,27.3779],"childNum":14},"geometry":{"type":"Polygon","coordinates":[[[109.248,28.4766],[109.248,29.1357],[109.5117,29.6191],[109.6875,29.6191],[109.7754,29.751],[110.4785,29.6631],[110.6543,29.751],[110.4785,30.0146],[110.8301,30.1465],[111.7969,29.9268],[112.2363,29.5313],[112.5,29.6191],[112.6758,29.5752],[112.9395,29.7949],[113.0273,29.751],[112.9395,29.4873],[113.0273,29.4434],[113.5547,29.8389],[113.5547,29.707],[113.7305,29.5752],[113.6426,29.3115],[113.7305,29.0918],[113.9063,29.0479],[114.1699,28.8281],[114.082,28.5645],[114.2578,28.3447],[113.7305,27.9492],[113.6426,27.5977],[113.6426,27.3779],[113.8184,27.29],[113.7305,27.1143],[113.9063,26.9385],[113.9063,26.6309],[114.082,26.5869],[113.9941,26.1914],[114.2578,26.1475],[113.9941,26.0596],[113.9063,25.4443],[113.6426,25.3125],[113.2031,25.5322],[112.8516,25.3564],[113.0273,25.2246],[113.0273,24.9609],[112.8516,24.917],[112.5879,25.1367],[112.2363,25.1807],[112.1484,24.873],[112.0605,24.7412],[111.709,24.7852],[111.5332,24.6533],[111.3574,25.1367],[111.0938,24.9609],[111.0059,25.0049],[111.4453,25.8398],[111.2695,25.8838],[111.2695,26.2354],[111.1816,26.3232],[110.5664,26.3232],[110.2148,25.9717],[109.9512,26.1914],[109.7754,25.8838],[109.5117,26.0156],[109.4238,26.2793],[109.248,26.3232],[109.4238,26.5869],[109.3359,26.7188],[109.5117,26.8066],[109.5117,27.0264],[109.3359,27.1582],[108.8965,27.0264],[108.8086,27.1143],[109.4238,27.5977],[109.3359,27.9053],[109.3359,28.2568],[109.248,28.4766]]]}},{"type":"Feature","properties":{"id":"61","name":"陕西","cp":[109.5996,35.6396],"childNum":10},"geometry":{"type":"Polygon","coordinates":[[[105.4688,32.915],[105.9082,33.0029],[105.9961,33.1787],[105.7324,33.3984],[105.9961,33.6182],[106.5234,33.5303],[106.4355,33.9258],[106.6113,34.1455],[106.5234,34.2773],[106.6992,34.3213],[106.3477,34.585],[106.5234,34.7607],[106.6113,35.0684],[106.9629,35.0684],[107.2266,34.8926],[107.666,34.9365],[107.8418,35.0244],[107.7539,35.1123],[107.7539,35.2881],[108.5449,35.2881],[108.6328,35.5518],[108.5449,35.8594],[108.6328,35.9912],[108.7207,36.3428],[107.3145,36.9141],[107.3145,37.0898],[107.3145,37.6172],[107.666,37.8809],[108.1934,37.6172],[108.7207,37.7051],[108.8086,38.0127],[108.8965,37.9688],[109.0723,38.0127],[108.9844,38.3203],[109.9512,39.1553],[109.8633,39.2432],[110.2148,39.2871],[110.127,39.4629],[110.6543,39.2871],[111.0938,39.5947],[111.0938,39.375],[111.1816,39.2432],[110.918,38.7158],[110.8301,38.4961],[110.4785,38.1885],[110.4785,37.9688],[110.8301,37.6611],[110.3906,37.002],[110.4785,36.123],[110.5664,35.6396],[110.2148,34.8926],[110.2148,34.6729],[110.3906,34.585],[110.4785,34.2334],[110.6543,34.1455],[110.6543,33.8379],[111.0059,33.5303],[111.0059,33.2666],[110.7422,33.1348],[110.5664,33.2666],[110.3027,33.1787],[109.5996,33.2666],[109.4238,33.1348],[109.7754,33.0469],[109.7754,32.915],[110.127,32.7393],[110.127,32.6074],[109.6875,32.6074],[109.5117,32.4316],[109.5996,31.7285],[109.248,31.7285],[109.0723,31.9482],[108.5449,32.2119],[108.2813,32.2559],[108.0176,32.168],[107.4023,32.5195],[107.2266,32.4316],[107.1387,32.4756],[107.0508,32.6953],[106.3477,32.6514],[106.084,32.7393],[106.084,32.8711],[105.5566,32.7393],[105.4688,32.915]]]}},{"type":"Feature","properties":{"id":"44","name":"广东","cp":[113.4668,22.8076],"childNum":21},"geometry":{"type":"Polygon","coordinates":[[[109.7754,21.4014],[109.7754,21.6211],[109.8633,21.665],[109.9512,21.8408],[110.3027,21.8848],[110.3027,22.1484],[110.6543,22.1484],[110.7422,22.2803],[110.7422,22.5439],[111.2695,22.8076],[111.4453,23.0273],[111.3574,23.4668],[111.6211,23.6865],[111.6211,23.8184],[111.7969,23.8184],[111.8848,23.9941],[111.8848,24.2139],[112.0605,24.3457],[111.8848,24.6533],[112.0605,24.7412],[112.1484,24.873],[112.2363,25.1807],[112.5879,25.1367],[112.8516,24.917],[113.0273,24.9609],[113.0273,25.2246],[112.8516,25.3564],[113.2031,25.5322],[113.6426,25.3125],[113.9063,25.4443],[113.9941,25.2686],[114.6094,25.4004],[114.7852,25.2686],[114.6973,25.1367],[114.4336,24.9609],[114.1699,24.6973],[114.4336,24.5215],[115.4004,24.7852],[115.8398,24.5654],[115.752,24.7852],[115.9277,24.917],[116.2793,24.7852],[116.3672,24.873],[116.543,24.6094],[116.7188,24.6533],[116.9824,24.1699],[116.9824,23.9063],[117.1582,23.5547],[117.334,23.2471],[116.8945,23.3789],[116.6309,23.1152],[116.543,22.8516],[115.9277,22.7197],[115.6641,22.7637],[115.5762,22.6318],[115.0488,22.6758],[114.6094,22.3682],[114.3457,22.5439],[113.9941,22.5],[113.8184,22.1924],[114.3457,22.1484],[114.4336,22.0166],[114.082,21.9287],[113.9941,21.7969],[113.5547,22.0166],[113.1152,21.8408],[112.9395,21.5771],[112.4121,21.4453],[112.2363,21.5332],[111.5332,21.4893],[111.2695,21.3574],[110.7422,21.3574],[110.6543,21.2256],[110.7422,20.918],[110.4785,20.874],[110.6543,20.5588],[110.5664,20.4288],[110.3906,20.327],[110.0391,20.337],[109.8633,20.327],[109.8633,20.3277],[109.5996,20.918],[109.7754,21.4014],[109.7754,21.4014]],[[113.5986,22.1649],[113.6096,22.1265],[113.5547,22.11],[113.5437,22.2034],[113.5767,22.2034],[113.5986,22.1649]]]}},{"type":"Feature","properties":{"id":"22","name":"吉林","cp":[126.4746,43.5938],"childNum":9},"geometry":{"type":"Polygon","coordinates":[[[123.2227,46.2305],[123.9258,46.2305],[124.0137,45.7471],[124.3652,45.4395],[124.8926,45.5273],[125.0684,45.3955],[125.6836,45.5273],[125.7715,45.3076],[126.0352,45.1758],[126.5625,45.2637],[126.9141,45.1318],[127.0898,45],[127.002,44.7803],[127.0898,44.6045],[127.5293,44.6045],[127.7051,44.1211],[128.0566,44.1211],[128.0566,44.3408],[128.4082,44.4727],[128.4961,44.165],[128.8477,43.5498],[129.1992,43.5938],[129.2871,43.8135],[129.8145,43.9014],[129.9023,44.0332],[129.9902,43.8574],[130.3418,43.9893],[130.5176,43.6377],[130.8691,43.418],[131.3086,43.4619],[131.3086,43.3301],[131.1328,42.9346],[130.4297,42.7148],[130.6055,42.6709],[130.6055,42.4512],[130.2539,42.7588],[130.2539,42.8906],[130.166,42.9785],[129.9023,43.0225],[129.7266,42.4951],[129.375,42.4512],[128.9355,42.0117],[128.0566,42.0117],[128.3203,41.5723],[128.1445,41.3525],[127.0898,41.5283],[127.1777,41.5723],[126.9141,41.792],[126.6504,41.6602],[126.4746,41.3965],[126.123,40.957],[125.6836,40.8691],[125.5957,40.9131],[125.7715,41.2207],[125.332,41.6602],[125.332,41.9678],[125.4199,42.0996],[125.332,42.1436],[124.8926,42.8027],[124.8926,43.0664],[124.7168,43.0664],[124.4531,42.8467],[124.2773,43.2422],[123.8379,43.4619],[123.6621,43.374],[123.3105,43.5059],[123.4863,43.7256],[123.1348,44.4727],[122.3438,44.2529],[122.0801,44.8682],[122.2559,45.2637],[121.9043,45.7031],[121.7285,45.7471],[121.8164,46.0107],[122.2559,45.791],[122.4316,45.8789],[122.6953,45.7031],[122.7832,46.0107],[123.2227,46.2305]]]}},{"type":"Feature","properties":{"id":"13","name":"河北","cp":[115.4004,37.9688],"childNum":11},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.5215,39.5068],[114.3457,39.8584],[113.9941,39.9902],[114.5215,40.3418],[114.3457,40.3857],[114.2578,40.6055],[114.082,40.7373],[113.9063,41.1328],[113.9941,41.2207],[113.9063,41.4404],[114.2578,41.5723],[114.1699,41.792],[114.5215,42.1436],[114.873,42.0996],[114.9609,41.6162],[115.2246,41.5723],[115.9277,41.9238],[116.0156,41.792],[116.2793,42.0117],[116.8066,42.0117],[116.8945,42.4072],[117.334,42.4512],[117.5098,42.583],[117.7734,42.627],[118.0371,42.4072],[117.9492,42.2314],[118.125,42.0557],[118.3008,42.0996],[118.3008,41.792],[118.125,41.748],[118.3887,41.3086],[119.2676,41.3086],[118.8281,40.8252],[119.2676,40.5176],[119.5313,40.5615],[119.707,40.1221],[119.8828,39.9463],[119.5313,39.6826],[119.4434,39.4189],[118.916,39.0674],[118.4766,38.9355],[118.125,39.0234],[118.0371,39.1992],[118.0371,39.2432],[117.8613,39.4189],[117.9492,39.5947],[117.6855,39.5947],[117.5098,39.7705],[117.5098,39.9902],[117.6855,39.9902],[117.6855,40.0781],[117.4219,40.21],[117.2461,40.5176],[117.4219,40.6494],[116.9824,40.6934],[116.6309,41.0449],[116.3672,40.9131],[116.4551,40.7813],[116.1914,40.7813],[116.1035,40.6055],[115.752,40.5615],[115.9277,40.2539],[115.4004,39.9463],[115.4883,39.6387],[115.752,39.5068],[116.1914,39.5947],[116.3672,39.4629],[116.543,39.5947],[116.8066,39.5947],[116.8945,39.1113],[116.7188,38.9355],[116.7188,38.8037],[117.2461,38.54],[117.5977,38.6279],[117.9492,38.3203],[117.4219,37.8369],[116.8066,37.8369],[116.4551,37.4854],[116.2793,37.5732],[116.2793,37.3535],[116.0156,37.3535],[115.752,36.9141],[115.3125,36.5186],[115.4883,36.167],[115.3125,36.0791],[115.1367,36.2109],[114.9609,36.0791],[114.873,36.123],[113.7305,36.3428],[113.4668,36.6504],[113.7305,36.8701],[113.7305,37.1338],[114.1699,37.6611],[113.9941,37.7051],[113.8184,38.1445],[113.5547,38.2764],[113.5547,38.54],[113.8184,38.8037],[113.8184,38.9355],[113.9063,39.0234],[114.3457,39.0674],[114.5215,39.5068]]],[[[117.2461,40.0781],[117.1582,39.8145],[117.1582,39.6387],[116.8945,39.6826],[116.8945,39.8145],[116.8066,39.9902],[117.2461,40.0781]]]]}},{"type":"Feature","properties":{"id":"42","name":"湖北","cp":[112.2363,31.1572],"childNum":17},"geometry":{"type":"Polygon","coordinates":[[[110.2148,31.1572],[110.127,31.377],[109.6875,31.5527],[109.7754,31.6846],[109.5996,31.7285],[109.5117,32.4316],[109.6875,32.6074],[110.127,32.6074],[110.127,32.7393],[109.7754,32.915],[109.7754,33.0469],[109.4238,33.1348],[109.5996,33.2666],[110.3027,33.1787],[110.5664,33.2666],[110.7422,33.1348],[111.0059,33.2666],[111.5332,32.6074],[112.3242,32.3438],[113.2031,32.4316],[113.4668,32.2998],[113.7305,32.4316],[113.8184,31.8604],[113.9941,31.7725],[114.1699,31.8604],[114.5215,31.7725],[114.6094,31.5527],[114.7852,31.4648],[115.1367,31.5967],[115.2246,31.4209],[115.4004,31.4209],[115.5762,31.2012],[116.0156,31.0254],[115.752,30.6738],[116.1035,30.1904],[116.1035,29.8389],[115.9277,29.707],[115.4883,29.7949],[114.873,29.3994],[114.2578,29.3555],[113.9063,29.0479],[113.7305,29.0918],[113.6426,29.3115],[113.7305,29.5752],[113.5547,29.707],[113.5547,29.8389],[113.0273,29.4434],[112.9395,29.4873],[113.0273,29.751],[112.9395,29.7949],[112.6758,29.5752],[112.5,29.6191],[112.2363,29.5313],[111.7969,29.9268],[110.8301,30.1465],[110.4785,30.0146],[110.6543,29.751],[110.4785,29.6631],[109.7754,29.751],[109.6875,29.6191],[109.5117,29.6191],[109.248,29.1357],[109.0723,29.3555],[108.9844,29.3115],[108.6328,29.8389],[108.457,29.7949],[108.5449,30.2344],[108.457,30.4102],[108.6328,30.5859],[108.8086,30.498],[109.0723,30.6299],[109.1602,30.542],[109.248,30.6299],[109.4238,30.542],[109.8633,30.8936],[110.0391,30.8057],[110.2148,31.1572]]]}},{"type":"Feature","properties":{"id":"52","name":"贵州","cp":[106.6113,26.9385],"childNum":9},"geometry":{"type":"Polygon","coordinates":[[[104.1504,27.2461],[104.4141,27.4658],[104.5898,27.334],[105.2051,27.3779],[105.293,27.7295],[105.5566,27.7734],[105.6445,27.6416],[106.3477,27.8174],[106.1719,28.125],[105.9082,28.125],[105.6445,28.4326],[105.9961,28.7402],[106.3477,28.5205],[106.5234,28.5645],[106.4355,28.7842],[106.5234,28.7842],[106.6113,28.6523],[106.6113,28.5205],[106.6992,28.4766],[106.875,28.7842],[107.4023,28.8721],[107.4023,29.1797],[107.5781,29.2236],[107.8418,29.1357],[107.8418,29.0039],[108.2813,29.0918],[108.3691,28.6523],[108.5449,28.6523],[108.5449,28.3887],[108.7207,28.4766],[108.7207,28.2129],[109.0723,28.2129],[109.248,28.4766],[109.3359,28.2568],[109.3359,27.9053],[109.4238,27.5977],[108.8086,27.1143],[108.8965,27.0264],[109.3359,27.1582],[109.5117,27.0264],[109.5117,26.8066],[109.3359,26.7188],[109.4238,26.5869],[109.248,26.3232],[109.4238,26.2793],[109.5117,26.0156],[109.3359,25.708],[108.9844,25.752],[109.0723,25.5322],[108.6328,25.5762],[108.6328,25.3125],[108.3691,25.5322],[108.1934,25.4443],[108.1055,25.2246],[107.8418,25.1367],[107.7539,25.2246],[107.4902,25.2246],[107.2266,25.6201],[106.9629,25.4883],[107.0508,25.2686],[106.875,25.1807],[106.1719,24.9609],[106.1719,24.7852],[105.9961,24.6533],[105.2051,24.9609],[104.6777,24.6094],[104.502,24.7412],[104.6777,24.9609],[104.5898,25.0488],[104.8535,25.2246],[104.3262,25.708],[104.6777,26.4111],[104.4141,26.6748],[103.8867,26.543],[103.7109,26.7627],[103.7109,26.9824],[103.623,27.0264],[103.8867,27.4219],[104.1504,27.2461]]]}},{"type":"Feature","properties":{"id":"37","name":"山东","cp":[118.7402,36.4307],"childNum":17},"geometry":{"type":"Polygon","coordinates":[[[115.4883,36.167],[115.3125,36.5186],[115.752,36.9141],[116.0156,37.3535],[116.2793,37.3535],[116.2793,37.5732],[116.4551,37.4854],[116.8066,37.8369],[117.4219,37.8369],[117.9492,38.3203],[118.125,38.1445],[118.916,38.1445],[119.3555,37.6611],[119.0039,37.5293],[119.0039,37.3535],[119.3555,37.1338],[119.707,37.1338],[119.8828,37.3975],[120.498,37.8369],[120.5859,38.1445],[120.9375,38.4521],[121.0254,37.8369],[121.2012,37.6611],[121.9043,37.4854],[122.168,37.6172],[122.2559,37.4854],[122.6074,37.4854],[122.6953,37.3535],[122.6074,36.9141],[122.4316,36.7822],[121.8164,36.8701],[121.7285,36.6943],[121.1133,36.6064],[121.1133,36.4307],[121.377,36.2549],[120.7617,36.167],[120.9375,35.8594],[120.6738,36.0352],[119.707,35.4639],[119.9707,34.9805],[119.3555,35.0244],[119.2676,35.1123],[118.916,35.0244],[118.7402,34.7168],[118.4766,34.6729],[118.3887,34.4092],[118.2129,34.4092],[118.125,34.6289],[117.9492,34.6729],[117.5977,34.4531],[117.334,34.585],[117.2461,34.4531],[116.8066,34.9365],[116.4551,34.8926],[116.3672,34.6289],[116.1914,34.585],[115.5762,34.585],[115.4004,34.8486],[114.7852,35.0684],[115.0488,35.376],[115.2246,35.4199],[115.4883,35.7275],[116.1035,36.0791],[115.3125,35.8154],[115.4883,36.167]]]}},{"type":"Feature","properties":{"id":"36","name":"江西","cp":[116.0156,27.29],"childNum":11},"geometry":{"type":"Polygon","coordinates":[[[114.2578,28.3447],[114.082,28.5645],[114.1699,28.8281],[113.9063,29.0479],[114.2578,29.3555],[114.873,29.3994],[115.4883,29.7949],[115.9277,29.707],[116.1035,29.8389],[116.2793,29.7949],[116.7188,30.0586],[116.8945,29.9268],[116.7188,29.751],[116.7188,29.6191],[117.1582,29.707],[117.0703,29.8389],[117.1582,29.9268],[117.5098,29.6191],[118.0371,29.5752],[118.2129,29.3994],[118.0371,29.1797],[118.0371,29.0479],[118.3887,28.7842],[118.4766,28.3447],[118.4766,28.3008],[118.3008,28.0811],[117.7734,27.8174],[117.5098,27.9932],[116.9824,27.6416],[117.1582,27.29],[117.0703,27.1143],[116.543,26.8066],[116.6309,26.4551],[116.3672,26.2354],[116.4551,26.1035],[116.1914,25.8838],[116.0156,25.2686],[115.8398,25.2246],[115.9277,24.917],[115.752,24.7852],[115.8398,24.5654],[115.4004,24.7852],[114.4336,24.5215],[114.1699,24.6973],[114.4336,24.9609],[114.6973,25.1367],[114.7852,25.2686],[114.6094,25.4004],[113.9941,25.2686],[113.9063,25.4443],[113.9941,26.0596],[114.2578,26.1475],[113.9941,26.1914],[114.082,26.5869],[113.9063,26.6309],[113.9063,26.9385],[113.7305,27.1143],[113.8184,27.29],[113.6426,27.3779],[113.6426,27.5977],[113.7305,27.9492],[114.2578,28.3447]]]}},{"type":"Feature","properties":{"id":"41","name":"河南","cp":[113.4668,33.8818],"childNum":17},"geometry":{"type":"Polygon","coordinates":[[[110.3906,34.585],[110.8301,34.6289],[111.1816,34.8047],[111.5332,34.8486],[111.7969,35.0684],[112.0605,35.0684],[112.0605,35.2881],[112.7637,35.2002],[113.1152,35.332],[113.6426,35.6836],[113.7305,36.3428],[114.873,36.123],[114.9609,36.0791],[115.1367,36.2109],[115.3125,36.0791],[115.4883,36.167],[115.3125,35.8154],[116.1035,36.0791],[115.4883,35.7275],[115.2246,35.4199],[115.0488,35.376],[114.7852,35.0684],[115.4004,34.8486],[115.5762,34.585],[116.1914,34.585],[116.1914,34.4092],[116.543,34.2773],[116.6309,33.9258],[116.1914,33.7061],[116.0156,33.9697],[115.6641,34.0576],[115.5762,33.9258],[115.5762,33.6621],[115.4004,33.5303],[115.3125,33.1787],[114.873,33.1348],[114.873,33.0029],[115.1367,32.8711],[115.2246,32.6074],[115.5762,32.4316],[115.8398,32.5195],[115.9277,31.7725],[115.4883,31.6846],[115.4004,31.4209],[115.2246,31.4209],[115.1367,31.5967],[114.7852,31.4648],[114.6094,31.5527],[114.5215,31.7725],[114.1699,31.8604],[113.9941,31.7725],[113.8184,31.8604],[113.7305,32.4316],[113.4668,32.2998],[113.2031,32.4316],[112.3242,32.3438],[111.5332,32.6074],[111.0059,33.2666],[111.0059,33.5303],[110.6543,33.8379],[110.6543,34.1455],[110.4785,34.2334],[110.3906,34.585]]]}},{"type":"Feature","properties":{"id":"21","name":"辽宁","cp":[122.3438,41.0889],"childNum":14},"geometry":{"type":"Polygon","coordinates":[[[119.2676,41.3086],[119.4434,41.6162],[119.2676,41.7041],[119.3555,42.2754],[119.5313,42.3633],[119.8828,42.1875],[120.1465,41.7041],[120.498,42.0996],[121.4648,42.4951],[121.7285,42.4512],[121.9922,42.7148],[122.3438,42.6709],[122.3438,42.8467],[122.7832,42.7148],[123.1348,42.8027],[123.3105,42.9785],[123.5742,43.0225],[123.6621,43.374],[123.8379,43.4619],[124.2773,43.2422],[124.4531,42.8467],[124.7168,43.0664],[124.8926,43.0664],[124.8926,42.8027],[125.332,42.1436],[125.4199,42.0996],[125.332,41.9678],[125.332,41.6602],[125.7715,41.2207],[125.5957,40.9131],[125.6836,40.8691],[124.541,40.21],[124.1016,39.6826],[123.3984,39.6826],[123.1348,39.4189],[123.1348,39.0234],[122.0801,39.0234],[121.5527,38.7158],[121.1133,38.6719],[120.9375,38.9795],[121.377,39.1992],[121.2012,39.5508],[122.0801,40.3857],[121.9922,40.6934],[121.7285,40.8252],[121.2012,40.8252],[120.5859,40.21],[119.8828,39.9463],[119.707,40.1221],[119.5313,40.5615],[119.2676,40.5176],[118.8281,40.8252],[119.2676,41.3086]]]}},{"type":"Feature","properties":{"id":"14","name":"山西","cp":[112.4121,37.6611],"childNum":11},"geometry":{"type":"Polygon","coordinates":[[[110.918,38.7158],[111.1816,39.2432],[111.0938,39.375],[111.3574,39.4189],[111.4453,39.6387],[111.9727,39.5947],[112.3242,40.2539],[112.7637,40.166],[113.2031,40.3857],[113.5547,40.3418],[113.8184,40.5176],[114.082,40.5176],[114.082,40.7373],[114.2578,40.6055],[114.3457,40.3857],[114.5215,40.3418],[113.9941,39.9902],[114.3457,39.8584],[114.5215,39.5068],[114.3457,39.0674],[113.9063,39.0234],[113.8184,38.9355],[113.8184,38.8037],[113.5547,38.54],[113.5547,38.2764],[113.8184,38.1445],[113.9941,37.7051],[114.1699,37.6611],[113.7305,37.1338],[113.7305,36.8701],[113.4668,36.6504],[113.7305,36.3428],[113.6426,35.6836],[113.1152,35.332],[112.7637,35.2002],[112.0605,35.2881],[112.0605,35.0684],[111.7969,35.0684],[111.5332,34.8486],[111.1816,34.8047],[110.8301,34.6289],[110.3906,34.585],[110.2148,34.6729],[110.2148,34.8926],[110.5664,35.6396],[110.4785,36.123],[110.3906,37.002],[110.8301,37.6611],[110.4785,37.9688],[110.4785,38.1885],[110.8301,38.4961],[110.918,38.7158]]]}},{"type":"Feature","properties":{"id":"34","name":"安徽","cp":[117.2461,32.0361],"childNum":17},"geometry":{"type":"Polygon","coordinates":[[[116.6309,33.9258],[116.543,34.2773],[116.1914,34.4092],[116.1914,34.585],[116.3672,34.6289],[116.8945,34.4092],[117.1582,34.0576],[117.5977,34.0137],[117.7734,33.7061],[118.125,33.75],[117.9492,33.2227],[118.0371,33.1348],[118.2129,33.2227],[118.3008,32.7832],[118.7402,32.7393],[118.916,32.959],[119.1797,32.8271],[119.1797,32.4756],[118.5645,32.5635],[118.6523,32.2119],[118.4766,32.168],[118.3887,31.9482],[118.916,31.5527],[118.7402,31.377],[118.8281,31.2451],[119.3555,31.2891],[119.4434,31.1572],[119.6191,31.1133],[119.6191,31.0693],[119.4434,30.6738],[119.2676,30.6299],[119.3555,30.4102],[118.916,30.3223],[118.916,29.9707],[118.7402,29.707],[118.2129,29.3994],[118.0371,29.5752],[117.5098,29.6191],[117.1582,29.9268],[117.0703,29.8389],[117.1582,29.707],[116.7188,29.6191],[116.7188,29.751],[116.8945,29.9268],[116.7188,30.0586],[116.2793,29.7949],[116.1035,29.8389],[116.1035,30.1904],[115.752,30.6738],[116.0156,31.0254],[115.5762,31.2012],[115.4004,31.4209],[115.4883,31.6846],[115.9277,31.7725],[115.8398,32.5195],[115.5762,32.4316],[115.2246,32.6074],[115.1367,32.8711],[114.873,33.0029],[114.873,33.1348],[115.3125,33.1787],[115.4004,33.5303],[115.5762,33.6621],[115.5762,33.9258],[115.6641,34.0576],[116.0156,33.9697],[116.1914,33.7061],[116.6309,33.9258]]]}},{"type":"Feature","properties":{"id":"35","name":"福建","cp":[118.3008,25.9277],"childNum":9},"geometry":{"type":"Polygon","coordinates":[[[118.4766,28.3008],[118.8281,28.2568],[118.7402,28.0371],[118.916,27.4658],[119.2676,27.4219],[119.6191,27.6855],[119.7949,27.29],[120.2344,27.4219],[120.4102,27.1582],[120.7617,27.0264],[120.6738,26.8945],[120.2344,26.8506],[120.2344,26.7188],[120.4102,26.6748],[120.498,26.3672],[120.2344,26.2793],[120.4102,26.1475],[120.0586,26.1914],[119.9707,25.9277],[119.7949,25.9277],[119.9707,25.4004],[119.7949,25.2686],[119.5313,25.1367],[119.4434,25.0049],[119.2676,25.0928],[118.916,24.8291],[118.6523,24.5215],[118.4766,24.5215],[118.4766,24.4336],[118.2129,24.3457],[118.2129,24.1699],[117.8613,23.9941],[117.7734,23.7744],[117.5098,23.5986],[117.1582,23.5547],[116.9824,23.9063],[116.9824,24.1699],[116.7188,24.6533],[116.543,24.6094],[116.3672,24.873],[116.2793,24.7852],[115.9277,24.917],[115.8398,25.2246],[116.0156,25.2686],[116.1914,25.8838],[116.4551,26.1035],[116.3672,26.2354],[116.6309,26.4551],[116.543,26.8066],[117.0703,27.1143],[117.1582,27.29],[116.9824,27.6416],[117.5098,27.9932],[117.7734,27.8174],[118.3008,28.0811],[118.4766,28.3008]]]}},{"type":"Feature","properties":{"id":"33","name":"浙江","cp":[120.498,29.0918],"childNum":11},"geometry":{"type":"Polygon","coordinates":[[[118.2129,29.3994],[118.7402,29.707],[118.916,29.9707],[118.916,30.3223],[119.3555,30.4102],[119.2676,30.6299],[119.4434,30.6738],[119.6191,31.0693],[119.6191,31.1133],[119.9707,31.1572],[120.498,30.8057],[120.9375,31.0254],[121.2891,30.6738],[121.9922,30.8057],[122.6953,30.8936],[122.8711,30.7178],[122.959,30.1465],[122.6074,30.1025],[122.6074,29.9268],[122.168,29.5313],[122.3438,28.8721],[121.9922,28.8721],[121.9922,28.4326],[121.7285,28.3447],[121.7285,28.2129],[121.4648,28.2129],[121.5527,28.0371],[121.2891,27.9492],[121.1133,27.4219],[120.6738,27.334],[120.6738,27.1582],[120.9375,27.0264],[120.7617,27.0264],[120.4102,27.1582],[120.2344,27.4219],[119.7949,27.29],[119.6191,27.6855],[119.2676,27.4219],[118.916,27.4658],[118.7402,28.0371],[118.8281,28.2568],[118.4766,28.3008],[118.4766,28.3447],[118.3887,28.7842],[118.0371,29.0479],[118.0371,29.1797],[118.2129,29.3994]]]}},{"type":"Feature","properties":{"id":"32","name":"江苏","cp":[120.0586,32.915],"childNum":13},"geometry":{"type":"Polygon","coordinates":[[[116.3672,34.6289],[116.4551,34.8926],[116.8066,34.9365],[117.2461,34.4531],[117.334,34.585],[117.5977,34.4531],[117.9492,34.6729],[118.125,34.6289],[118.2129,34.4092],[118.3887,34.4092],[118.4766,34.6729],[118.7402,34.7168],[118.916,35.0244],[119.2676,35.1123],[119.3555,35.0244],[119.3555,34.8486],[119.707,34.585],[120.3223,34.3652],[120.9375,33.0469],[121.0254,32.6514],[121.377,32.4756],[121.4648,32.168],[121.9043,31.9922],[121.9922,31.6846],[121.9922,31.5967],[121.2012,31.8604],[121.1133,31.7285],[121.377,31.5088],[121.2012,31.4648],[120.9375,31.0254],[120.498,30.8057],[119.9707,31.1572],[119.6191,31.1133],[119.4434,31.1572],[119.3555,31.2891],[118.8281,31.2451],[118.7402,31.377],[118.916,31.5527],[118.3887,31.9482],[118.4766,32.168],[118.6523,32.2119],[118.5645,32.5635],[119.1797,32.4756],[119.1797,32.8271],[118.916,32.959],[118.7402,32.7393],[118.3008,32.7832],[118.2129,33.2227],[118.0371,33.1348],[117.9492,33.2227],[118.125,33.75],[117.7734,33.7061],[117.5977,34.0137],[117.1582,34.0576],[116.8945,34.4092],[116.3672,34.6289]]]}},{"type":"Feature","properties":{"id":"50","name":"重庆","cp":[107.7539,30.1904],"childNum":40},"geometry":{"type":"Polygon","coordinates":[[[108.5449,31.6846],[108.2813,31.9043],[108.3691,32.168],[108.5449,32.2119],[109.0723,31.9482],[109.248,31.7285],[109.5996,31.7285],[109.7754,31.6846],[109.6875,31.5527],[110.127,31.377],[110.2148,31.1572],[110.0391,30.8057],[109.8633,30.8936],[109.4238,30.542],[109.248,30.6299],[109.1602,30.542],[109.0723,30.6299],[108.8086,30.498],[108.6328,30.5859],[108.457,30.4102],[108.5449,30.2344],[108.457,29.7949],[108.6328,29.8389],[108.9844,29.3115],[109.0723,29.3555],[109.248,29.1357],[109.248,28.4766],[109.0723,28.2129],[108.7207,28.2129],[108.7207,28.4766],[108.5449,28.3887],[108.5449,28.6523],[108.3691,28.6523],[108.2813,29.0918],[107.8418,29.0039],[107.8418,29.1357],[107.5781,29.2236],[107.4023,29.1797],[107.4023,28.8721],[106.875,28.7842],[106.6992,28.4766],[106.6113,28.5205],[106.6113,28.6523],[106.5234,28.7842],[106.4355,28.7842],[106.5234,28.5645],[106.3477,28.5205],[106.2598,28.8721],[105.8203,28.96],[105.7324,29.2676],[105.4688,29.3115],[105.293,29.5313],[105.7324,29.8828],[105.5566,30.1025],[105.6445,30.2783],[105.8203,30.4541],[106.2598,30.1904],[106.6113,30.3223],[106.7871,30.0146],[107.0508,30.0146],[107.4902,30.6299],[107.4023,30.7617],[107.4902,30.8496],[107.9297,30.8496],[108.1934,31.5088],[108.5449,31.6846]]]}},{"type":"Feature","properties":{"id":"64","name":"宁夏","cp":[105.9961,37.3096],"childNum":5},"geometry":{"type":"Polygon","coordinates":[[[104.3262,37.4414],[105.8203,37.793],[105.9082,38.7158],[106.3477,39.2871],[106.7871,39.375],[106.9629,38.9795],[106.5234,38.3203],[106.7871,38.1885],[107.3145,38.1006],[107.666,37.8809],[107.3145,37.6172],[107.3145,37.0898],[106.6113,37.0898],[106.6113,36.7822],[106.4355,36.5625],[106.5234,36.4746],[106.5234,36.2549],[106.875,36.123],[106.9629,35.8154],[106.6992,35.6836],[106.4355,35.6836],[106.5234,35.332],[106.3477,35.2441],[106.2598,35.4199],[106.084,35.376],[105.9961,35.4199],[106.084,35.4639],[105.9961,35.4639],[105.8203,35.5518],[105.7324,35.7275],[105.3809,35.7715],[105.293,35.9912],[105.4688,36.123],[105.2051,36.6943],[105.293,36.8262],[104.8535,37.2217],[104.5898,37.2217],[104.5898,37.4414],[104.3262,37.4414]]]}},{"type":"Feature","properties":{"id":"46","name":"海南","cp":[109.9512,19.2041],"childNum":18},"geometry":{"type":"Polygon","coordinates":[[[108.6328,19.3799],[109.0723,19.6436],[109.248,19.9512],[109.5996,20.0391],[110.0391,20.127],[110.3906,20.127],[110.5664,20.2588],[110.6543,20.2588],[111.0938,19.9512],[111.2695,19.9951],[110.6543,19.1602],[110.5664,18.6768],[110.2148,18.5889],[110.0391,18.3691],[109.8633,18.3691],[109.6875,18.1055],[108.9844,18.2813],[108.6328,18.457],[108.6328,19.3799]]]}},{"type":"Feature","properties":{"id":"71","name":"台湾","cp":[121.0254,23.5986],"childNum":1},"geometry":{"type":"Polygon","coordinates":[[[121.9043,25.0488],[121.9922,25.0049],[121.8164,24.7412],[121.9043,24.5654],[121.6406,24.0381],[121.377,23.1152],[121.0254,22.6758],[120.8496,22.0605],[120.7617,21.9287],[120.6738,22.3242],[120.2344,22.5879],[120.0586,23.0713],[120.1465,23.6865],[121.0254,25.0488],[121.5527,25.3125],[121.9043,25.0488]]]}},{"type":"Feature","properties":{"id":"11","name":"北京","cp":[116.4551,40.2539],"childNum":19},"geometry":{"type":"Polygon","coordinates":[[[117.4219,40.21],[117.334,40.1221],[117.2461,40.0781],[116.8066,39.9902],[116.8945,39.8145],[116.8945,39.6826],[116.8066,39.5947],[116.543,39.5947],[116.3672,39.4629],[116.1914,39.5947],[115.752,39.5068],[115.4883,39.6387],[115.4004,39.9463],[115.9277,40.2539],[115.752,40.5615],[116.1035,40.6055],[116.1914,40.7813],[116.4551,40.7813],[116.3672,40.9131],[116.6309,41.0449],[116.9824,40.6934],[117.4219,40.6494],[117.2461,40.5176],[117.4219,40.21]]]}},{"type":"Feature","properties":{"id":"12","name":"天津","cp":[117.4219,39.4189],"childNum":18},"geometry":{"type":"Polygon","coordinates":[[[116.8066,39.5947],[116.8945,39.6826],[117.1582,39.6387],[117.1582,39.8145],[117.2461,40.0781],[117.334,40.1221],[117.4219,40.21],[117.6855,40.0781],[117.6855,39.9902],[117.5098,39.9902],[117.5098,39.7705],[117.6855,39.5947],[117.9492,39.5947],[117.8613,39.4189],[118.0371,39.2432],[118.0371,39.1992],[117.8613,39.1113],[117.5977,38.6279],[117.2461,38.54],[116.7188,38.8037],[116.7188,38.9355],[116.8945,39.1113],[116.8066,39.5947]]]}},{"type":"Feature","properties":{"id":"31","name":"上海","cp":[121.4648,31.2891],"childNum":19},"geometry":{"type":"Polygon","coordinates":[[[120.9375,31.0254],[121.2012,31.4648],[121.377,31.5088],[121.1133,31.7285],[121.2012,31.8604],[121.9922,31.5967],[121.9043,31.1572],[121.9922,30.8057],[121.2891,30.6738],[120.9375,31.0254]]]}},{"type":"Feature","properties":{"id":"81","name":"香港","cp":[114.2578,22.3242],"childNum":1},"geometry":{"type":"Polygon","coordinates":[[[114.6094,22.4121],[114.5215,22.1484],[114.3457,22.1484],[113.9063,22.1484],[113.8184,22.1924],[113.9063,22.4121],[114.1699,22.5439],[114.3457,22.5439],[114.4336,22.5439],[114.4336,22.4121],[114.6094,22.4121]]]}},{"type":"Feature","properties":{"id":"82","name":"澳门","cp":[113.5547,22.1484],"childNum":1},"geometry":{"type":"Polygon","coordinates":[[[113.5986,22.1649],[113.6096,22.1265],[113.5547,22.11],[113.5437,22.2034],[113.5767,22.2034],[113.5986,22.1649]]]}}]}

/***/ }),

/***/ "jMem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/1/17.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirAccordion',
  provide: function provide() {
    return {
      panelClick: this.panelClick,
      focusable: this.focusable
    };
  },

  props: {
    value: [Number, Array],
    expand: Boolean,
    focusable: Boolean,
    inset: Boolean,
    popout: Boolean
  },
  data: function data() {
    return {
      children: [],
      activeArr: [],
      mValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      this.mValue = val;
    },
    mValue: function mValue(val) {
      this.init(val);
      // this.children.forEach(c => c.toggle(0))
      // this.children[val] && this.children[val].toggle()
      // this.$emit('input', val)
    },
    activeArr: function activeArr() {
      var indexArr = [];
      this.activeArr.forEach(function (v, i) {
        v && indexArr.push(i);
      });
      if (!this.expand) {
        this.$emit('input', indexArr[0]);
      } else {
        this.$emit('input', indexArr);
      }
    }
  },
  mounted: function mounted() {
    this.children = this.$children.filter(function (c) {
      return c.$options && c.$options.name === 'AirAccordionContent';
    });
    this.init(this.value);
  },

  methods: {
    init: function init(val) {
      var _this = this;

      if (!this.expand) {
        this.children.forEach(function (c) {
          return c.toggle(0);
        });
        this.children[val] && this.children[val].toggle();
      } else {
        this.children.forEach(function (c, i) {
          if (val.includes(i)) {
            if (!c.isActive) {
              c.toggle();
            }
          } else {
            c.toggle(0);
          }
        });
        val.forEach(function (v) {
          if (!_this.children[v].isActive) {
            _this.children[v].toggle();
          }
        });
      }
      this.$emit('input', val);
      // this.activeArr = new Array(this.children.length).fill(false)
      // if (this.value !== undefined) {
      //   if (typeof this.value === 'number') {
      //     if (this.value >= 0) {
      //       this.activeArr[this.value] = true
      //       this.children[this.value].toggle()
      //     }
      //   } else {
      //     this.value.forEach(i => {
      //       this.activeArr[i] = true
      //       this.children[i].toggle()
      //     })
      //   }
      // }
    },
    getChildren: function getChildren() {
      return this.$children.filter(function (c) {
        return c.$options && c.$options.name === 'AirAccordionContent';
      });
    },
    panelClick: function panelClick(uid, isActive) {
      this.changeActive(uid, isActive);
      var children = this.getChildren();

      if (!this.expand) {
        for (var index = children.length; --index >= 0;) {
          children[index].toggle(uid);
        }
        return;
      }

      for (var _index = children.length; --_index >= 0;) {
        if (children[_index]._uid === uid) {
          children[_index].toggle(uid);
          return;
        }
      }
    },
    changeActive: function changeActive(uid, isActive) {
      var index = this.children.findIndex(function (c) {
        return c._uid === uid;
      });
      if (!this.expand) {
        this.mValue = isActive ? index : -1;
        // this.activeArr = new Array(this.children.length).fill(false)
      } else {
        var index2 = this.mValue.indexOf(index);
        if (index2 >= 0) {
          this.mValue.splice(index2, 1);
        } else {
          this.mValue.push(index);
        }
      }
    }
  },
  render: function render(h) {
    return h('ul', {
      staticClass: 'air-accordion',
      'class': {
        'air-accordion--focusable': this.focusable,
        'air-accordion--popout': this.popout,
        'air-accordion--inset': this.inset
      }
    }, this.$slots.default);
  }
});

/***/ }),

/***/ "jnjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","preserveAspectRatio":"xMidYMid","fill":_vm.fill}},[_c('circle',{attrs:{"cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(45 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.125s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(90 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.25s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(135 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.375s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(180 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.5s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(225 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.625s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(270 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.75s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(315 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.875s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})]),_vm._v(" "),_c('circle',{attrs:{"transform":"rotate(180 16 16)","cx":"16","cy":"3","r":"0"}},[_c('animate',{attrs:{"attributeName":"r","values":"0;3;0;0","dur":"1s","repeatCount":"indefinite","begin":"0.5s","keySplines":"0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8","calcMode":"spline"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kw13":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ky4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_IndexSelect_vue__ = __webpack_require__("VP5F");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/11/15.
 */


__WEBPACK_IMPORTED_MODULE_0__src_IndexSelect_vue__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_IndexSelect_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_IndexSelect_vue__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_IndexSelect_vue__["a" /* default */]);

/***/ }),

/***/ "lFDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_DataBlock_vue__ = __webpack_require__("LLUP");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/11/15.
 */


__WEBPACK_IMPORTED_MODULE_0__src_DataBlock_vue__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_DataBlock_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_DataBlock_vue__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_DataBlock_vue__["a" /* default */]);

/***/ }),

/***/ "lO2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexList_vue__ = __webpack_require__("64zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43db415e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexList_vue__ = __webpack_require__("yQko");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43db415e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lxMp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/1/17.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  Bootable: {
    name: 'bootable',
    data: function data() {
      return {
        isBooted: false
      };
    },
    props: {
      lazy: Boolean
    },
    watch: {
      isActive: function isActive() {
        this.isBooted = true;
      }
    },
    methods: {
      showLazyContent: function showLazyContent(content) {
        return this.isBooted || !this.lazy ? content : null;
      }
    }
  },
  Toggle: {
    name: 'toggleable',
    model: { prop: 'value', event: 'input' },
    props: {
      value: { required: false }
    },
    data: function data() {
      return {
        isActive: !!this.value
      };
    },

    watch: {
      value: function value(val) {
        this.isActive = !!val;
      },
      isActive: function isActive(val) {
        !!val !== this.value && this.$emit('input', val);
      }
    }
  }
});

/***/ }),

/***/ "m4Eu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723927a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("mo9J");
function injectStyle (ssrContext) {
  __webpack_require__("wuJt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-723927a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723927a7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("wv90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("NwlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_demo_block_vue__ = __webpack_require__("7IlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_index_js__ = __webpack_require__("gGbG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_theme_css_index_css__ = __webpack_require__("zJFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_theme_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__packages_theme_css_index_css__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('demo-block', __WEBPACK_IMPORTED_MODULE_3__components_demo_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__packages_index_js__["a" /* default */], { mouseWheel: true });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "mo9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-footer"},[_c('div',{staticClass:"footer-container"},[_c('span',{staticClass:"icon"},[_c('svg',{attrs:{"onclick":"location.href='https://github.com/ccqiuqiu/AirUI'","aria-hidden":"true","height":"60","version":"1.1","viewBox":"0 0 16 16","width":"40"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"}})])]),_vm._v(" "),_c('span',[_vm._v("贡献者：")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/ccqiuqiu"}},[_vm._v("ccqiuqiu")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ogF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__ = __webpack_require__("GCGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_esm_addMonths__ = __webpack_require__("Fj1y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_esm_startOfMonth__ = __webpack_require__("FlAw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_esm_isBefore__ = __webpack_require__("Yo08");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_esm_startOfDay__ = __webpack_require__("Hv5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_esm_endOfMonth__ = __webpack_require__("x4Xh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_esm_eachDayOfInterval__ = __webpack_require__("l8Vd");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirCalendarV',
  props: {
    num: {
      type: Number,
      default: 12
    },
    startSun: {
      type: Boolean,
      default: false
    },
    weekBg: {
      type: String,
      default: 'air-calendar-v--wbg'
    },
    date: String,
    date2: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    data2: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currency: {
      type: String,
      default: '￥'
    },
    double: {
      type: Boolean,
      default: false
    },
    titles: {
      type: Array,
      default: function _default() {
        return ['出发日期', '返回日期'];
      }
    },
    btnText: {
      type: String,
      default: '确定'
    }
  },
  data: function data() {
    return {
      monthList: this.initData(), // 基础日历，仅日期数据
      select: 1,
      activeDate1: this.date ? {
        date: new Date(this.date),
        format: this.date
      } : {},
      activeDate2: this.date ? {
        date: new Date(this.date2),
        format: this.date2
      } : {}

    };
  },

  computed: {
    isBefore: function isBefore() {
      return Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm_isBefore__["a" /* default */])(this.activeDate1.date, this.activeDate2.date);
    },
    weeks: function weeks() {
      var w = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()('一二三四五六日'));
      if (this.startSun) {
        w.pop();
        w.unshift('日');
      }
      return w;
    },

    // 切换要显示的数据
    renderData: function renderData() {
      return !this.double || this.select === 1 ? this.data : this.data2;
    },

    // 最终要渲染的日历，包含了所有数据
    renderList: function renderList() {
      var _this = this;

      return this.monthList.map(function (month) {
        // 先取出当前月的价格
        var ps = _this.renderData.filter(function (p) {
          return p.date.substr(0, 7) === Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(month.y + '-' + month.m2, 'YYYY-MM');
        });
        // 取出当前月的最低价
        var lowPrice = Math.min.apply(null, ps.map(function (p) {
          return Number(p.text) || 0;
        }));

        // 组装需要的数据
        var ds = month.ds.map(function (date) {
          if (date) {
            var dateStr = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(date, 'YYYY-MM-DD');
            var p = ps.find(function (p) {
              return p.date === dateStr;
            }); // 从价格数据里面获取当前日期的价格对象
            var price = p ? p.text : 0;
            // 标识状态
            var state = 0;
            // 今天前，或者选择第二个日期的时候，第一个日期前 都是 -1
            var d = Object(__WEBPACK_IMPORTED_MODULE_6_date_fns_esm_startOfDay__["a" /* default */])(new Date());
            if (Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm_isBefore__["a" /* default */])(date, d) || _this.select === 2 && Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm_isBefore__["a" /* default */])(date, _this.activeDate1.date)) {
              state = -1;
            } else if (dateStr === _this.activeDate1.format) {
              state = 1;
            } else if (dateStr === _this.activeDate2.format) {
              state = 3;
            } else if (!Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm_isBefore__["a" /* default */])(date, _this.activeDate1.date) && Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm_isBefore__["a" /* default */])(date, _this.activeDate2.date)) {
              state = 2;
            }
            return {
              date: date,
              format: dateStr,
              d: Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(date, 'D'),
              w: parseInt(Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(date, 'd')),
              price: price,
              state: state,
              low: price === lowPrice
            };
          } else {
            return false;
          }
        });

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, month, {
          lowPrice: lowPrice,
          ds: ds
        });
      });
    }
  },
  mounted: function mounted() {
    // 如果有传初始激活的日期，那么自动滚动到日期的位置
    var dom = this.$el.querySelector('.active1');
    dom && dom.scrollIntoViewIfNeeded();
  },

  methods: {
    initData: function initData() {
      var _this2 = this;

      // 起始日是当月的第一天
      var startDate = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns_esm_startOfMonth__["a" /* default */])(new Date());
      var monthList = new Array(this.num).fill('').map(function (item, i) {
        return _this2.createMonthData(Object(__WEBPACK_IMPORTED_MODULE_3_date_fns_esm_addMonths__["a" /* default */])(startDate, i));
      });
      return monthList;
    },

    // 创建一个月的数据
    createMonthData: function createMonthData(start) {
      var month = {
        y: Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(start, 'YYYY'),
        m: Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(start, 'M'),
        m2: Object(__WEBPACK_IMPORTED_MODULE_2_date_fns_esm_format__["a" /* default */])(start, 'MM')
      };
      var weekStart = this.startSun ? 0 : 1;
      // 月的最后一天
      var end = Object(__WEBPACK_IMPORTED_MODULE_7_date_fns_esm_endOfMonth__["a" /* default */])(start);
      // 生成第一天到最后一天的数据
      var arr = Object(__WEBPACK_IMPORTED_MODULE_8_date_fns_esm_eachDayOfInterval__["a" /* default */])({ start: start, end: end });
      // 补全第一天不是在星期的开始的时候的空位，如第一天是周3  就要补全周2、周1 2个空位
      var start_w = start.getDay() || 7;
      arr.unshift.apply(arr, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new Array(start_w - weekStart).fill(false)));
      // 补全最后一天不是在星期的结束的时候的空位，如最后一天是周3  就要补全周4、周5、周6、周日 4个空位
      var end_w = end.getDay();
      arr.push.apply(arr, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new Array(Math.max(7 - end_w - weekStart, 0)).fill(false)));

      month.ds = arr;
      return month;
    },
    clickDate: function clickDate(month, date) {
      if (date.state === 0 || date.state === 2) {
        this['activeDate' + this.select] = date;
        if (this.double) {
          this.select = 3 - this.select;
        }
      }
    },
    selected: function selected() {
      this.$emit('selected', this.double ? [this.activeDate1, this.activeDate2] : this.activeDate1);
    }
  }
});

/***/ }),

/***/ "qD8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-slide-action"},[_c('v-touch',{staticClass:"air-slide-action--touch",style:(_vm.styleObject),attrs:{"pan-options":{direction: 'horizontal'}},on:{"panmove":_vm.onPanMove,"panend":_vm.onPanEnd,"panstart":_vm.onPanStart}},[(_vm.$slots.left)?_c('span',{ref:"left",staticClass:"air-slide-action--left"},[_vm._t("left")],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"air-slide-action--con"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.right)?_c('span',{ref:"right",staticClass:"air-slide-action--right"},[_vm._t("right")],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qEhS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("0EIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32cc2772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("jnjt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32cc2772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rzs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_IndexList_vue__ = __webpack_require__("lO2E");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2017/11/15.
 */


__WEBPACK_IMPORTED_MODULE_0__src_IndexList_vue__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_IndexList_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_IndexList_vue__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_IndexList_vue__["a" /* default */]);

/***/ }),

/***/ "sjmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debounce_js__ = __webpack_require__("JiD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__("LfK9");



/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds (or once per browser frame). The throttled function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `throttle` and `debounce`.
 *
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0]
 *  The number of milliseconds to throttle invocations to; if omitted,
 *  `requestAnimationFrame` is used (if available).
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', throttle(updatePosition, 100))
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * const throttled = throttle(renewToken, 300000, { 'trailing': false })
 * jQuery(element).on('click', throttled)
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel)
 */
function throttle(func, wait, options) {
  var leading = true;
  var trailing = true;

  if (typeof func != 'function') {
    throw new TypeError('Expected a function');
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__debounce_js__["a" /* default */])(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ __webpack_exports__["a"] = (throttle);

/***/ }),

/***/ "tsiT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideActionGroup_vue__ = __webpack_require__("RWRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_902c1a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideActionGroup_vue__ = __webpack_require__("0enS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideActionGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_902c1a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideActionGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wezC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_side_nav_vue__ = __webpack_require__("zkq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d561f0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_nav_vue__ = __webpack_require__("erXO");
function injectStyle (ssrContext) {
  __webpack_require__("Qy8M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_side_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d561f0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wuJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wv90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("JJYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52721aea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("xf5A");
function injectStyle (ssrContext) {
  __webpack_require__("ONGs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52721aea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xOCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/1/17.
 */
function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    name: name,

    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}
function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function ExpandTransitionGenerator() {
  var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    enter: function enter(el, done) {
      el._parent = el.parentNode;

      addOnceEventListener(el, 'transitionend', done);

      // Get height that is to be scrolled
      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.display = 'block';
      expandedParentClass && el._parent.classList.add(expandedParentClass);

      setTimeout(function () {
        return el.style.height = el.scrollHeight + 'px';
      }, 100);
    },
    afterEnter: function afterEnter(el) {
      el.style.overflow = null;
      //el.style.height = null
    },
    leave: function leave(el, done) {
      // Remove initial transition
      addOnceEventListener(el, 'transitionend', done);

      // Set height before we transition to 0
      el.style.overflow = 'hidden';
      el.style.height = el.offsetHeight + 'px';

      setTimeout(function () {
        return el.style.height = 0;
      }, 100);
    },
    afterLeave: function afterLeave(el) {
      expandedParentClass && el._parent.classList.remove(expandedParentClass);
    }
  };
}

var ExpandTransition = createJavaScriptTransition('expand-transition', ExpandTransitionGenerator());

/***/ }),

/***/ "xZ3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.md)?_c('div',{staticClass:"pulldown-md",style:({top: _vm.top + 'px'})},[_c('div',{staticClass:"icon"},[_c('div',{staticClass:"svg",class:{loading: _vm.isPullingDown},style:(_vm.iconStyle)},[_vm._t("icon",[_c('svg',{attrs:{"t":"1539047037871","viewBox":"0 0 1024 1024","version":"1.1","p-id":"1035"}},[_c('path',{attrs:{"d":"M960 416V192l-73.056 73.056a447.712 447.712 0 0 0-373.6-201.088C265.92 63.968 65.312 264.544 65.312 512S265.92 960.032 513.344 960.032a448.064 448.064 0 0 0 415.232-279.488 38.368 38.368 0 1 0-71.136-28.896 371.36 371.36 0 0 1-344.096 231.584C308.32 883.232 142.112 717.024 142.112 512S308.32 140.768 513.344 140.768c132.448 0 251.936 70.08 318.016 179.84L736 416h224z","p-id":"1036"}})])])],2)])]):_c('div',{ref:"pulldown",staticClass:"pulldown-wrapper",style:({top: _vm.top + 'px'})},[(_vm.beforePullDown)?_c('div',{staticClass:"before-trigger"},[_c('bubble',{attrs:{"y":_vm.bubbleY}})],1):_c('div',{staticClass:"after-trigger"},[(_vm.isPullingDown)?_c('div',[_c('loading')],1):_c('div',[_c('span',[_vm._v(_vm._s(_vm.refreshTxt))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xf5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mainHeader'),_vm._v(" "),(!_vm.isIndex)?_c('div',{staticClass:"container"},[_c('sideNav',{staticClass:"nav"}),_vm._v(" "),_c('router-view',{staticClass:"view"})],1):_c('router-view',{staticClass:"page"}),_vm._v(" "),(!_vm.isIndex)?_c('mainFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xhpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("xOCk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__("lxMp");
/**
 * Created by 熊超超(https://github.com/ccqiuqiu) on 2018/1/17.
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AirAccordionContent',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */].Bootable, __WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* default */].Toggle],
  inject: ['focusable', 'panelClick'],
  data: function data() {
    return {
      height: 'auto'
    };
  },

  props: {},
  methods: {
    genBody: function genBody() {
      return this.$createElement('div', {
        ref: 'body',
        class: 'air-accordion__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, this.showLazyContent(this.$slots.default));
    },
    genHeader: function genHeader() {
      var _this = this;

      return this.$createElement('div', {
        staticClass: 'air-accordion__header',
        on: {
          click: function click() {
            return _this.panelClick(_this._uid, !_this.isActive);
          }
        }
      }, [this.$slots.header, this.genIcon()]);
    },
    genIcon: function genIcon(h) {
      return this.$slots.icon ? this.$createElement('div', {
        staticClass: 'arrow-icon'
      }, [this.$slots.icon]) : null;
    },
    toggle: function toggle() {
      var _this2 = this;

      var uid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._uid;

      var isActive = this._uid === uid && !this.isActive;
      if (isActive) {
        this.isBooted = true;
      }
      this.$nextTick(function () {
        return _this2.isActive = isActive;
      });
    }
  },
  render: function render(h) {
    var _this3 = this;

    var children = [];
    this.$slots.header && children.push(this.genHeader());
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* ExpandTransition */], [this.genBody()]));
    return h('li', {
      staticClass: 'air-accordion__container',
      'class': {
        'air-accordion__container--active': this.isActive
      },
      attrs: {
        tabindex: 0
      },
      on: {
        keydown: function keydown(e) {
          // 确保元素是可聚焦的活动的元素
          if (_this3.focusable && _this3.$el === document.activeElement && e.keyCode === 13) _this3.panelClick(_this3._uid);
        }
      }
    }, children);
  }
});

/***/ }),

/***/ "yQko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-index-select scroll"},[_c('div',{staticClass:"air-index-select__top"},[_c('div',{staticClass:"air-index-select__search",class:_vm.searchClass},[_c('div',[_vm._t("icon"),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.keyword),expression:"keyword",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":_vm.searchHit},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})],2)]),_vm._v(" "),(_vm.tabs)?_c('div',{staticClass:"air-index-select__tab"},_vm._l((_vm.tabs),function(tab,index){return _c('span',{style:({borderColor: index === _vm.tabIndex ? _vm.activeColor : 'transparent', color: index === _vm.tabIndex ? '#333333' : '#AAAAAA'}),on:{"click":function($event){_vm.tabIndex=index}}},[_vm._v(_vm._s(tab))])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"air-index-select__content"},[_c('scroll',{ref:"scroll",staticClass:"air-index-select__list",attrs:{"noRoot":"","listenScroll":"","probeType":2,"scrollbar":false},on:{"scroll":_vm.scroll}},[(_vm.hisText)?_c('dl',{directives:[{name:"show",rawName:"v-show",value:(!_vm.keyword),expression:"!keyword"}],class:['air-index-select__dl', 'air-index-select__key-his', _vm.hisClass]},[_c('dt',[_vm._t("his",[_vm._v("历史")])],2),_vm._v(" "),_c('dd',_vm._l((_vm.hisData),function(item){return _c('span',{key:item[_vm.keyField],on:{"click":function($event){_vm.clickItem(item)}}},[_vm._v(_vm._s(item[_vm.textField]))])}))]):_vm._e(),_vm._v(" "),_c('dl',{directives:[{name:"show",rawName:"v-show",value:(!_vm.keyword),expression:"!keyword"}],class:['air-index-select__dl', 'air-index-select__key-hot', _vm.hotClass]},[_c('dt',[_vm._t("hot",[_vm._v("热门")])],2),_vm._v(" "),_c('dd',_vm._l((_vm.hotData),function(item){return _c('span',{key:item[_vm.keyField],class:_vm.getHightLineClass(item[_vm.keyField]),on:{"click":function($event){_vm.clickItem(item)}}},[_vm._v(_vm._s(item[_vm.textField]))])}))]),_vm._v(" "),_vm._l((_vm.listData),function(value,key){return _c('dl',{key:key,class:['air-index-select__dl', 'air-index-select__key-'+key]},[_c('dt',[_vm._v(_vm._s(key))]),_vm._v(" "),_vm._l((value),function(item){return _c('dd',{key:item[_vm.keyField],on:{"click":function($event){_vm.clickItem(item)}}},[_vm._t("default",[_c('span',{staticClass:"air-index-select__text"},[_vm._v(_vm._s(item[_vm.textField]))]),_vm._v(" "),_c('span',{staticClass:"air-index-select__sub-text"},[_vm._v(_vm._s(item[_vm.subTextField]))])],{item:item})],2)})],2)})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(/[A-Z]/.test(_vm.active) && _vm.fixTitle),expression:"/[A-Z]/.test(active) && fixTitle"}],staticClass:"air-index-select__title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.active))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.keyword),expression:"!keyword"}],class:['air-index-select__index', {'air-index-select__index--tabs': !!_vm.tabs}, _vm.indexClass],on:{"touchstart":function($event){$event.stopPropagation();$event.preventDefault();_vm.touchstart($event)},"touchmove":function($event){$event.stopPropagation();$event.preventDefault();_vm.touchmove($event)},"touchend":function($event){$event.stopPropagation();$event.preventDefault();_vm.touchend($event)}}},[_vm._l((_vm.index),function(char){return [(char === _vm.active)?_c('span',{staticClass:"air-index-select__char air-index-select__char--active",style:({color:_vm.activeColor}),on:{"click":function($event){_vm.clickChar(char)}}},[_vm._v(_vm._s(char))]):_c('span',{staticClass:"air-index-select__char",on:{"click":function($event){_vm.clickChar(char)}}},[_vm._v(_vm._s(char))])]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTip),expression:"showTip"}],staticClass:"air-index-select__tip"},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yyt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "z2fs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"air-scroll",style:({position: _vm.noRoot ? 'relative': 'absolute'})},[_c('div',{ref:"listWrapper",staticClass:"scroll-content"},[_vm._t("default"),_vm._v(" "),_vm._t("pullup",[(_vm.pullUpLoad)?_c('div',{staticClass:"pullup-wrapper"},[(!_vm.isPullUpLoad)?_c('div',{staticClass:"before-trigger"},[_c('span',[_vm._v(_vm._s(_vm.pullUpTxt))])]):_c('div',{staticClass:"after-trigger"},[_vm._t("loading",[_c('loading')])],2)]):_vm._e()],{pullUpLoad:_vm.pullUpLoad,isPullUpLoad:_vm.isPullUpLoad})],2),_vm._v(" "),_vm._t("pulldown",[(_vm.pullDownRefresh)?_c('pull-down',{ref:"pulldown",staticClass:"pulldown-wrapper",attrs:{"bubbleY":_vm.bubbleY,"refreshTxt":_vm.refreshTxt,"top":_vm.pullDownStyle,"md":_vm.md,"beforePullDown":_vm.beforePullDown,"isPullingDown":_vm.isPullingDown}},[_vm._t("icon",null,{slot:"icon"})],2):_vm._e()],{pullDownRefresh:_vm.pullDownRefresh,pullDownStyle:_vm.pullDownStyle,beforePullDown:_vm.beforePullDown,isPullingDown:_vm.isPullingDown,bubbleY:_vm.bubbleY})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zJFi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zfcq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_config_json__ = __webpack_require__("ffz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nav_config_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: __WEBPACK_IMPORTED_MODULE_0__nav_config_json___default.a
    };
  }
});

/***/ })

},["mUtA"]);


// WEBPACK FOOTER //
// static/js/app.84a2e8901368c36b41d1.js